(function() {
'use strict';

/* Utils — lazy resolved on first use */
var _U;
function _ensureUtils() {
  if (_U) return;
  _U = window.IsoDashUtils || {};
  createRuntimeScope = _U.createRuntimeScope;
  getProject = _U.getProject;
  escapeHTML = _U.escapeHTML;
  masonryLabel = _U.masonryLabel;
  formatEuro = _U.formatEuro;
  computeDerived = _U.computeDerived;
  renderFreigabeChecklist = _U.renderFreigabeChecklist;
}
var createRuntimeScope, getProject, escapeHTML, masonryLabel, formatEuro, computeDerived, renderFreigabeChecklist;

/**
 * ╔══════════════════════════════════════════════════════════════╗
 * ║  ISODASH Module: Analyse (Feuchtigkeits-Analyse)             ║
 * ║  Orchestriert IsoDash Steps 0–3 im Dashboard Content-Bereich ║
 * ║                                                              ║
 * ║  v3: Entry → Step 0 Kapillar → Wall Wizard (opt. FA2 inline) ║
 * ║  Nach Step 3 → calculateFinalAnalysis() → navigate('uebersicht')  ║
 * ╚══════════════════════════════════════════════════════════════╝
 */

/* ═══ CONSTANTS ═══ */
var STEP_ORDER = ['step-1', 'step-0', 'step-2', 'step-3'];

var STEP_FILES = [
  'dashboard-step-0.js',   // Index 0: Wandmaße + Lage
  'dashboard-step-1.js',   // Index 1: Feuchtigkeitstyp (aufsteigend/seitlich)
  'dashboard-step-2.js',   // Index 2: Mauerwerk
  'dashboard-step-3.js'    // Index 3: Wandstärke + Ecken
];

/* CDN-URLs — bei Self-Hosting auf Shopify-Assets umstellen:
   var REACT_CDN = getAssetBase() + 'react.production.min.js';
   var REACT_DOM_CDN = getAssetBase() + 'react-dom.production.min.js'; */
var REACT_CDN = 'https://cdnjs.cloudflare.com/ajax/libs/react/18.2.0/umd/react.production.min.js';
var REACT_DOM_CDN = 'https://cdnjs.cloudflare.com/ajax/libs/react-dom/18.2.0/umd/react-dom.production.min.js';

/* ═══ FA2 (Feuchtigkeitsanalyse) FILES ═══ */
var FA2_FILES = [
  'dashboard-fa-content-de.js',
  'dashboard-fa-ssot-diagnose.js'
];

var MC_QUESTIONS = ['q1','q2','q3','q4','q5','q6','q7','q8'];

/* ═══ DARK THEME CSS (injected at mount, removed at unmount) ═══ */
var DARK_THEME_CSS_ID = 'isodash-analyse-dark-theme';

function injectDarkThemeCSS() {
  /* CSS ausgelagert → isodash-analyse.css */
}

function removeDarkThemeCSS() {
  var el = document.getElementById(DARK_THEME_CSS_ID);
  if (el && el.parentNode) el.parentNode.removeChild(el);
}


/* ═══ MODULE STATE ═══ */
var _rootEl = null;
var _storeRef = null;
var _navigateRef = null;
var _isMobile = false;
var _currentStepIndex = 0;
var _currentStepModule = null;
var _sharedState = {};
var _ctx = null;
var _mounted = false;
/* Standalone-Modus (gesetzt via mountCtx aus isodash-standalone.js):
   _faMode='fa-only' → nur Feuchtigkeitsanalyse, KEIN Bedarfsrechner;
   _faDoneUrl → Ziel statt Wall-Wizard (z.B. /pages/kalkulator). Im Dashboard beide leer. */
var _faMode = false;
var _faDoneUrl = null;
var _faDoneBottom = null;
var _faDoneSide = null;

/* ═══ FLOW STATE (entry → moisture-check → wall-wizard) ═══ */
var _flowPhase = 'entry'; // 'entry' | 'step0-capillary' | 'moisture-check' | 'wall-wizard' | 'transition' | 'exit'
var _mcAnswers = {};
var _mcQuestionIndex = 0;
var _mcResult = null;

/* ═══ FLOW STATE HELPERS (sessionStorage) ═══ */
function setFlowState(key, value) {
  try { sessionStorage.setItem(key, String(value)); } catch(_e) {}
}

function getFlowState(key) {
  try { return sessionStorage.getItem(key); } catch(_e) { return null; }
}

function clearFlowState() {
  /* In-Memory FA-State zurücksetzen — verhindert dass alte Antworten
     bei "Analyse neu starten" wieder benutzt werden und Steps überspringen.
     WICHTIG: Objekt-Referenz behalten (nicht ersetzen!) damit _ctx.state
     weiterhin auf dasselbe Objekt zeigt. */
  try {
    for (var k in _sharedState) { if (_sharedState.hasOwnProperty(k)) delete _sharedState[k]; }
    _mcAnswers = {};
    _mcQuestionIndex = 0;
    _mcResult = null;
    _currentStepIndex = 0;
    /* _ctx.state Referenz aktualisieren falls ctx existiert */
    if (_ctx && _ctx.state !== _sharedState) _ctx.state = _sharedState;
  } catch(_) {}
  /* Session-Keys */
  var sessionKeys = [
    'isodash_flow_phase', 'isodash_entry_mode', 'isodash_capillary_fit',
    'isodash_capillary_confidence', 'isodash_capillary_check',
    'isodash_moisture_check_completed', 'isodash_analysis_source',
    'isodash_masonry_type', 'isodash_moisture_type'
  ];
  sessionKeys.forEach(function(k) {
    try { sessionStorage.removeItem(k); } catch(_e) {}
  });
  /* localStorage-Keys (Berechnungsdaten, FA, Wizard) */
  var storageKeys = [
    'isofinAnalysis', '__ISOWIZ_analysis', '__ISOWIZ_RESUME_ANALYSIS__',
    'fa_state_v2', '__ISOWIZ_state__', '__ISOWIZ_share_state__',
    'isodash_nav_unlock_shown', 'isodash_a2c_done',
    'isodash_transition_shown'  /* Transition-Flag → neue Berechnung = neue Transition */
  ];
  storageKeys.forEach(function(k) {
    try { localStorage.removeItem(k); } catch(_e) {}
    try { sessionStorage.removeItem(k); } catch(_e) {}
  });
  /* In-Memory Berechnung clearen */
  try {
    if (window.IsoDash && window.IsoDash.Calculations && typeof window.IsoDash.Calculations.clearAnalysis === 'function') {
      window.IsoDash.Calculations.clearAnalysis();
    }
  } catch(_e) {}
  /* Shared State zurücksetzen (Properties löschen, Referenz behalten) */
  for (var _ck in _sharedState) { if (_sharedState.hasOwnProperty(_ck)) delete _sharedState[_ck]; }
}

/* ═══ HELPERS ═══ */
function getAssetBase() {
  return window.ISODASH_ASSET_BASE || '/assets/';
}

function vUrl(url) {
  var v = window.ISODASH_VERSION || '8.0.15';
  return url + (url.indexOf('?') === -1 ? '?' : '&') + 'v=' + encodeURIComponent(v);
}

function loadScript(url, useVersioning) {
  return new Promise(function (resolve, reject) {
    var s = document.createElement('script');
    s.src = useVersioning !== false ? vUrl(url) : url;
    s.async = true;
    s.onload = function () { resolve(); };
    s.onerror = function () { reject(new Error('Script load failed: ' + url)); };
    (document.head || document.documentElement).appendChild(s);
  });
}

/* ═══ ISODASH NAMESPACE SHIMS ═══ */
function ensureNamespace() {
  var w = window;
  w.IsoDash = w.IsoDash || {};
  w.IsoDash.Steps = w.IsoDash.Steps || {};
  w.IsoDash.__loaded = w.IsoDash.__loaded || {};

  /* Config (minimal, genug für die Steps) */
  if (!w.IsoDash.Config) {
    w.IsoDash.Config = Object.freeze({
      BUILD_ID: '26.1.0',
      ASSET_VERSION: '26.1.0',
      STORAGE_PREFIX: 'isodash-wiz',
      STEP_ORDER: Object.freeze(STEP_ORDER.slice()),
      STEP_PROGRESS: Object.freeze({
        'step-0': { showInProgress: true, progressLabel: 'Wanddaten' },
        'step-1': { showInProgress: true, progressLabel: 'Verfahren' },
        'step-2': { showInProgress: true, progressLabel: 'Mauerwerk' },
        'step-3': { showInProgress: true, progressLabel: 'Wanddicke' }
      }),
      TRUST: Object.freeze({
        'step-0': { enabled: false, mode: 'none' },
        'step-1': { enabled: false, mode: 'none' },
        'step-2': { enabled: false, mode: 'none' },
        'step-3': { enabled: false, mode: 'none' }
      }),
      product: Object.freeze({
        basePrice: 19.9,
        discountThresholds: Object.freeze({ 50: 18.9, 250: 17.9 }),
        variantId: 55049427616117
      }),
      RULES: Object.freeze({ allowDirectGoTo: true, enforceStepGateLoading: false, allowResume: false })
    });
  }

  /* Storage shim (local/session backed, inkl. TTL) */
  if (!w.IsoDash.Storage) {
    var storagePrefix = (w.IsoDash.Config && w.IsoDash.Config.STORAGE_PREFIX) || 'isodash-wiz';
    var keyOf = function (k) { return storagePrefix + ':' + String(k || ''); };
    var parseRaw = function (raw) {
      if (raw == null) return null;
      try { return JSON.parse(raw); } catch (_e) { return raw; }
    };
    var unwrapTTL = function (key, value, defaultValue) {
      var isTTL = value && typeof value === 'object'
        && (
          value.__isodashWizTTL === 1
          || (Object.prototype.hasOwnProperty.call(value, 'expiresAt') && Object.prototype.hasOwnProperty.call(value, 'value'))
        );
      if (isTTL) {
        var exp = Number(value.expiresAt) || 0;
        if (exp > 0 && Date.now() > exp) {
          try { localStorage.removeItem(key); } catch (_e1) {}
          try { sessionStorage.removeItem(key); } catch (_e2) {}
          return defaultValue;
        }
        return value.value;
      }
      return value;
    };
    var readRaw = function (key) {
      var raw = null;
      try { raw = localStorage.getItem(key); } catch (_e1) {}
      if (raw != null) return raw;
      try { raw = sessionStorage.getItem(key); } catch (_e2) {}
      return raw;
    };
    var writeRaw = function (key, raw) {
      var ok = false;
      try { localStorage.setItem(key, raw); ok = true; } catch (_e1) {}
      try { sessionStorage.setItem(key, raw); ok = true; } catch (_e2) {}
      return ok;
    };

    w.IsoDash.Storage = {
      get: function (k, d) {
        var key = keyOf(k);
        var raw = readRaw(key);
        if (raw == null) return d;
        var parsed = parseRaw(raw);
        return unwrapTTL(key, parsed, d);
      },
      set: function (k, v) {
        var key = keyOf(k);
        try {
          return writeRaw(key, JSON.stringify(v));
        } catch (_e) {
          return false;
        }
      },
      setWithTTL: function (k, v, ttlMs) {
        var key = keyOf(k);
        var ttl = Math.max(0, Number(ttlMs) || 0);
        var payload = {
          __isodashWizTTL: 1,
          value: v,
          expiresAt: ttl > 0 ? (Date.now() + ttl) : 0
        };
        try {
          return writeRaw(key, JSON.stringify(payload));
        } catch (_e) {
          return false;
        }
      },
      remove: function (k) {
        var key = keyOf(k);
        try { localStorage.removeItem(key); } catch (_e1) {}
        try { sessionStorage.removeItem(key); } catch (_e2) {}
      },
      getJSON: function (k, d) {
        var v = this.get(k, null);
        if (v == null) return d;
        if (typeof v === 'object') return v;
        if (typeof v === 'string') {
          try { return JSON.parse(v); } catch (_e) { return d; }
        }
        return d;
      },
      setJSON: function (k, v) {
        return this.set(k, v);
      },
      getWithTTL: function (k, d) {
        return this.get(k, d);
      }
    };
  }

  /* UI shim (scrollToTop scrollt den Dashboard-Content-Bereich) */
  if (!w.IsoDash.UI) {
    w.IsoDash.UI = {
      scrollToTop: function () {
        var ct = document.getElementById('ct');
        if (ct) { try { ct.scrollTo({ top: 0, behavior: 'smooth' }); } catch (_e) { ct.scrollTop = 0; } }
      },
      renderProgress: function () { return true; },
      injectStyleOnce: function (id, css) {
        if (!id || document.getElementById(id)) return false;
        var s = document.createElement('style');
        s.id = id;
        s.textContent = String(css || '');
        document.head.appendChild(s);
        return true;
      },
      ensureBaseCssLoaded: function () {},
      renderStep: function () { return true; },
      renderFatal: function () { return true; },
      mountOverlay: function () { return { close: function () {}, el: null }; },
      unmountOverlay: function () { return true; },
      showToast: function () { return true; }
    };
  }

  /* Preload stub (Steps rufen das auf, um nächsten Step vorzuladen — im Dashboard unnötig) */
  if (typeof w.IsoDash.preloadStep !== 'function') {
    w.IsoDash.preloadStep = function () { return Promise.resolve(); };
  }
  if (typeof w.IsoDash.ensureStepLoaded !== 'function') {
    w.IsoDash.ensureStepLoaded = function () { return Promise.resolve(); };
  }
  if (typeof w.IsoDash.observeStepForPrefetch !== 'function') {
    w.IsoDash.observeStepForPrefetch = function () {};
  }
}

/* ═══ NAVIGATION SHIM ═══ */
function _pushStepState(stepId) {
  if (window.history && window.history.pushState) {
    try { window.history.pushState({ isodashWizStep: stepId }, '', ''); } catch (e) {}
  }
}

function createNavShim() {
  return {
    goNext: function () {
      if (!_mounted) return false;
      /* Track completed step */
      var _completedStep = STEP_ORDER[_currentStepIndex];
      var _stepTrackNames = { 'step-0': 'isodash-wiz-s0-wandlaenge', 'step-1': 'isodash-wiz-s1-feuchteart', 'step-2': 'isodash-wiz-s2-mauerwerk', 'step-3': 'isodash-wiz-s3-wanddicke' };
      if (_stepTrackNames[_completedStep]) { window.logr3Track && window.logr3Track(_stepTrackNames[_completedStep], { step: true }); }
      if (_currentStepIndex >= STEP_ORDER.length - 1) {
        onAllStepsComplete();
        return true;
      }
      unmountCurrentStep();
      _currentStepIndex++;
      /* Skip step-1 (Feuchtigkeitstyp) wenn moistureType bereits durch FA2 gesetzt */
      if (STEP_ORDER[_currentStepIndex] === 'step-1' && _sharedState.moistureType) {
        _currentStepIndex++;
      }
      /* Skip step-2 (Mauerwerk) wenn masonryType bereits durch FA2 q8 gesetzt */
      if (STEP_ORDER[_currentStepIndex] === 'step-2' && _sharedState.masonryType) {
        _currentStepIndex++;
      }
      if (_currentStepIndex >= STEP_ORDER.length) {
        onAllStepsComplete();
        return true;
      }
      _pushStepState(STEP_ORDER[_currentStepIndex]);
      renderCurrentStep();
      return true;
    },
    goPrev: function () {
      if (!_mounted) return false;
      if (_currentStepIndex <= 0) {
        /* Erster Step: zurück zum Entry-Screen via history.back */
        try { window.history.back(); } catch(_){}
        return true;
      }
      /* Browser-History zurück → popstate Handler übernimmt die Navigation */
      try { window.history.back(); } catch(_){}
      return true;
    },
    /* Interner Prev ohne history.back (wird vom popstate Handler aufgerufen) */
    _goPrevInternal: function () {
      if (!_mounted || _currentStepIndex <= 0) return false;
      unmountCurrentStep();
      _currentStepIndex--;
      if (STEP_ORDER[_currentStepIndex] === 'step-2' && _sharedState.masonryType && _currentStepIndex > 0) _currentStepIndex--;
      if (STEP_ORDER[_currentStepIndex] === 'step-1' && _sharedState.moistureType && _currentStepIndex > 0) _currentStepIndex--;
      renderCurrentStep();
      return true;
    },
    goTo: function (stepId) {
      var idx = STEP_ORDER.indexOf(stepId);
      if (idx < 0 || !_mounted) return false;
      unmountCurrentStep();
      _currentStepIndex = idx;
      _pushStepState(stepId);
      renderCurrentStep();
      return true;
    },
    getState: function () {
      return { stepId: STEP_ORDER[_currentStepIndex], viewState: 'step', direction: 'next' };
    },
    subscribe: function () { return function () {}; },
    registerStep: function () { return true; },
    normalizeStep: function (s, f) { return STEP_ORDER.indexOf(s) !== -1 ? s : f; },
    getNext: function (stepId) {
      var i = STEP_ORDER.indexOf(stepId);
      return i >= 0 && i < STEP_ORDER.length - 1 ? STEP_ORDER[i + 1] : null;
    },
    getPrevious: function (stepId) {
      var i = STEP_ORDER.indexOf(stepId);
      return i > 0 ? STEP_ORDER[i - 1] : null;
    },
    getProgressModel: function () {
      return { steps: [], currentIndex: _currentStepIndex, total: STEP_ORDER.length };
    },
    init: function () { return true; },
    start: function () { return true; },
    requestNext: function () { return { needsConfirm: false, ok: true }; },
    commitNext: function () { return true; },
    cancelOverlay: function () { return true; },
    cancelPendingOverlay: function () { return true; }
  };
}

function setupSafeNav() {
  window.IsoDash.safeGoNext = function (ctx) {
    if (ctx && ctx.nav && typeof ctx.nav.goNext === 'function') ctx.nav.goNext();
  };
  window.IsoDash.safeGoPrev = function (ctx) {
    if (ctx && ctx.nav && typeof ctx.nav.goPrev === 'function') ctx.nav.goPrev();
  };

  /* Steps rufen manchmal IsoDash_backToHero auf — im Dashboard navigieren wir zum Entry Screen */
  window.IsoDash_backToHero = function () {
    if (_mounted) {
      unmountCurrentStep();
      clearFlowState();
      _flowPhase = 'entry';
      renderEntryScreen(_rootEl);
    }
  };
}

/* ═══ STEP RENDERING ═══ */
function unmountCurrentStep() {
  if (_currentStepModule) {
    if (typeof _currentStepModule.destroy === 'function') {
      try { _currentStepModule.destroy(); } catch (e) { console.warn('[IsoDash Analyse] destroy error', e); }
    }
    _currentStepModule = null;
  }
  /* Cleanup: Body-Overflows die Steps setzen könnten */
  try { document.body.style.overflow = ''; } catch (_e) {}
  try { document.body.style.overscrollBehavior = ''; } catch (_e) {}
  try { document.documentElement.style.overflowY = ''; } catch (_e) {}
}

function renderCurrentStep() {
  if (!_rootEl || !_mounted) return;

  var stepId = STEP_ORDER[_currentStepIndex];

  /* Sicherstellen, dass das Step-Script geladen ist */
  var mod = window.IsoDash.Steps[stepId];
  if (!mod || typeof mod.render !== 'function') {
    /* Step noch nicht geladen — lade nach und versuche erneut */
    _rootEl.innerHTML = ''
      + '<div style="text-align:center !important;padding:40px 20px !important">'
      + '<div style="width:32px !important;height:32px !important;margin:0 auto 12px !important;border:3px solid rgba(255,255,255,.1) !important;border-top-color:#D6001C !important;border-radius:50% !important;animation:isodash-analyse-spin 1s linear infinite !important"></div>'
      + '<div style="font-size:12px !important;color:var(--ds-text-muted) !important">Schritt wird geladen\u2026</div>'
      + '</div>';
    ensureCurrentStepLoaded().then(function () {
      if (!_mounted) return;
      var mod2 = window.IsoDash.Steps[stepId];
      if (mod2 && typeof mod2.render === 'function') {
        doRenderStep(stepId, mod2);
      } else {
        _rootEl.innerHTML = '<div style="text-align:center !important;padding:40px !important;color:var(--ds-text-muted) !important">Step-Modul ' + stepId + ' konnte nicht geladen werden.</div>';
      }
    }).catch(function () {
      if (_mounted) _rootEl.innerHTML = '<div style="text-align:center !important;padding:40px !important;color:var(--ds-text-muted) !important">Ladefehler.</div>';
    });
    return;
  }

  doRenderStep(stepId, mod);
}

function doRenderStep(stepId, mod) {
  _currentStepModule = mod;

  /* Update ctx with current step info */
  _ctx.stepId = stepId;
  _ctx.navState = { stepId: stepId, direction: 'next', viewState: 'step' };

  /* Clear and render */
  _rootEl.innerHTML = '';
  mod.render(_rootEl, _ctx);

  /* Scroll ALLES nach oben — Dashboard-Content UND innere Wizard-Scroll-Container.
     Jeder Step-Wechsel (vor/zurück) muss oben anfangen, nie die alte Scrollposition behalten. */
  var ct = document.getElementById('ct');
  if (ct) { try { ct.scrollTo({ top: 0 }); } catch (_e) { ct.scrollTop = 0; } }
  /* Innere Scroll-Container der Wizard-Steps (Mobile: position:fixed → eigener Scroll) */
  try {
    var scrollEls = _rootEl.querySelectorAll('.step1-content, .s2-cnt, .s3-cnt, .step1-right, .s2-right, .s3-right, .ihub-mc-scroll, .wiz-card-body');
    for (var _si = 0; _si < scrollEls.length; _si++) { scrollEls[_si].scrollTop = 0; }
  } catch(_) {}

  /* Touch-Ghost-Click verhindern: Nur kurz (150ms) damit User den Drawer schnell
     antippen kann. 150ms reicht damit der Touchend vom vorherigen Button-Tap
     nicht durchschlägt, aber ein frischer Tap auf dem neuen Screen sofort reagiert. */
  try {
    if (window.innerWidth < 768) {
      var blockEl = _rootEl;
      blockEl.style.setProperty('pointer-events', 'none', 'important');
      setTimeout(function(){
        try { blockEl.style.removeProperty('pointer-events'); } catch(_){}
      }, 150);
    }
  } catch(_) {}
}

/* ══════════════════════════════════════════════════════════════
   ═══ CALCULATION LOADING SCREEN ═══
   Animated checklist showing calculation progress before
   the transition/results screen. Dark-themed adaptation of
   the IsoDash Step 4 loading screen.
   ══════════════════════════════════════════════════════════════ */

function renderCalculationScreen() {
  if (!_rootEl) return;
  _flowPhase = 'calculating';

  /* Preload JetBrains Mono for labels */
  if (!document.querySelector('link[href*="JetBrains"]')) {
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@400;700;800&display=swap';
    document.head.appendChild(link);
  }

  var CHECK_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>';
  var SHIELD_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>';

  _rootEl.innerHTML =
    '<div class="ihub-calc">' +
      '<div class="calc-card" id="calc-card">' +

        '<div class="calc-header">' +
          '<div class="calc-eyebrow">' +
            '<div class="calc-status-dot"></div>' +
            '<svg class="calc-status-check" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>' +
            '<span id="calc-statusText">System-Pr\u00FCfung l\u00E4uft\u2026</span>' +
          '</div>' +
          '<h2 class="calc-heading" id="calc-heading">Berechne Sanierungsplan</h2>' +

          '<div class="calc-progress-wrap">' +
            '<div class="calc-progress-bar" id="calc-pbar" style="width:0%"></div>' +
          '</div>' +
          '<div class="calc-progress-labels">' +
            '<span id="calc-plabel">Validiere Mauerwerksdaten\u2026</span>' +
            '<span id="calc-ppct">0%</span>' +
          '</div>' +
        '</div>' +

        '<div class="calc-checklist">' +

          '<div class="calc-item" id="calc-step-1">' +
            '<div class="calc-item-num">01</div>' +
            '<div class="calc-item-icon">' + CHECK_SVG + '</div>' +
            '<div class="calc-item-content">' +
              '<h3>Technische Eignung best\u00E4tigt</h3>' +
              '<p>Ihr Mauerwerk ist f\u00FCr das Injektionsverfahren geeignet. Die Voraussetzungen f\u00FCr eine sichere Ausf\u00FChrung sind erf\u00FCllt.</p>' +
            '</div>' +
          '</div>' +

          '<div class="calc-item" id="calc-step-2">' +
            '<div class="calc-item-num">02</div>' +
            '<div class="calc-item-icon">' + CHECK_SVG + '</div>' +
            '<div class="calc-item-content">' +
              '<h3>Individueller Bohrplan erstellt</h3>' +
              '<p>Bohrwinkel, Lochabst\u00E4nde und Bohrtiefe wurden exakt auf Ihre Wand abgestimmt.</p>' +
            '</div>' +
          '</div>' +

          '<div class="calc-item" id="calc-step-3">' +
            '<div class="calc-item-num">03</div>' +
            '<div class="calc-item-icon">' + CHECK_SVG + '</div>' +
            '<div class="calc-item-content">' +
              '<h3>Wirkung rechnerisch gepr\u00FCft</h3>' +
              '<p>Die berechnete Injektionsmenge blockiert kapillar aufsteigende Feuchtigkeit dauerhaft.</p>' +
            '</div>' +
          '</div>' +

          '<div class="calc-item" id="calc-step-4">' +
            '<div class="calc-item-num">04</div>' +
            '<div class="calc-item-icon">' + SHIELD_SVG + '</div>' +
            '<div class="calc-item-content">' +
              '<h3>Lebenslange Garantie freigegeben</h3>' +
              '<p>Ihr Projekt ist technisch gepr\u00FCft und freigegeben \u2014 Sie erhalten unsere vertragliche Wirksamkeits-Garantie.</p>' +
            '</div>' +
          '</div>' +

        '</div>' +
      '</div>' +
    '</div>';

  /* Scroll to top */
  var ct = document.getElementById('ct');
  if (ct) { try { ct.scrollTo({ top: 0, behavior: 'smooth' }); } catch (_e) { ct.scrollTop = 0; } }
}

/* Progress bar animation helper */
function _calcAnimateProgressTo(targetPct, durationMs) {
  var pbar = document.getElementById('calc-pbar');
  var ppct = document.getElementById('calc-ppct');
  if (!pbar) return;

  var computed = 0;
  try { computed = parseFloat(pbar.style.width || '0'); } catch (_) {}
  if (!Number.isFinite(computed)) computed = 0;
  var startPct = Math.max(0, Math.min(100, computed));
  var endPct = Math.max(0, Math.min(100, Number(targetPct) || 0));
  if (endPct <= startPct) {
    pbar.style.width = endPct + '%';
    if (ppct) ppct.textContent = Math.round(endPct) + '%';
    return;
  }

  var startTs = 0;
  var duration = Math.max(100, Number(durationMs) || 700);

  function tick(ts) {
    if (!startTs) startTs = ts;
    var t = (ts - startTs) / duration;
    if (t > 1) t = 1;
    var eased = 1 - Math.pow(1 - t, 3); /* ease-out cubic */
    var current = startPct + (endPct - startPct) * eased;
    pbar.style.width = current + '%';
    if (ppct) ppct.textContent = Math.round(current) + '%';
    if (t < 1) {
      window.requestAnimationFrame(tick);
    } else {
      pbar.style.width = endPct + '%';
      if (ppct) ppct.textContent = Math.round(endPct) + '%';
    }
  }
  window.requestAnimationFrame(tick);
}

/* Activate a checklist step */
function _calcActivateStep(stepNum, pct, labelText) {
  var el = document.getElementById('calc-step-' + stepNum);
  var plabel = document.getElementById('calc-plabel');
  if (el) el.classList.add('active');
  _calcAnimateProgressTo(pct, 900);
  if (plabel) plabel.textContent = labelText;
}

/**
 * Animates the 4 calculation steps (~7s total).
 * Returns a Promise that resolves when complete.
 */
function animateCalculationSteps() {
  return new Promise(function (resolve) {
    var T = {
      init: 260,
      s1: 1200,
      s2: 2800,
      s3: 4400,
      s4: 6000
    };

    setTimeout(function () {
      _calcAnimateProgressTo(15, 900);
    }, T.init);

    /* Step 1 */
    setTimeout(function () {
      _calcActivateStep(1, 35, 'Simuliere Kapillars\u00E4ttigung\u2026');
    }, T.s1);

    /* Step 2 */
    setTimeout(function () {
      _calcActivateStep(2, 65, 'Optimiere Bohrraster\u2026');
    }, T.s2);

    /* Step 3 */
    setTimeout(function () {
      _calcActivateStep(3, 85, 'Pr\u00FCfe Zulassungsrichtlinien\u2026');
    }, T.s3);

    /* Step 4 — Final */
    setTimeout(function () {
      _calcActivateStep(4, 100, 'System-Diagnose erfolgreich abgeschlossen.');

      var card = document.getElementById('calc-card');
      var statusText = document.getElementById('calc-statusText');
      var heading = document.getElementById('calc-heading');

      if (card) card.classList.add('is-done');
      if (statusText) statusText.textContent = 'Pr\u00FCfung abgeschlossen';
      if (heading) heading.innerHTML = '\u2705 Ihr Projekt ist freigegeben';

      /* Short pause, then resolve to continue to transition screen */
      setTimeout(resolve, 800);
    }, T.s4);
  });
}


/* ═══ AFTER STEP 3: CALCULATE & NAVIGATE ═══ */
function onAllStepsComplete() {
  unmountCurrentStep();
  window.logr3Track && window.logr3Track("isodash-berechnung-start", { step: true });

  /* ── 1. Show Calculation Loading Screen ── */
  renderCalculationScreen();

  /* ── 2. Run actual calculation (synchronous, happens instantly) ── */
  var S = _sharedState;
  var moistureType = S.moistureType || 'bottom';
  var masonryType = S.masonryType || 'ziegel';
  var wallLengthM = S.wallLengthM || (S.wallLengthCm ? S.wallLengthCm / 100 : 0);
  var surfaceLengthM = S.surfaceLengthM || (S.surfaceLengthCm ? S.surfaceLengthCm / 100 : 0);
  var surfaceHeightM = S.surfaceHeightM || (S.surfaceHeightCm ? S.surfaceHeightCm / 100 : 0);
  var cornerCount = parseInt(S.cornerCount, 10) || 0;
  var wallThickness = parseInt(S.wallThickness, 10) || 36;

  var calcState = {
    moistureType: moistureType,
    masonryType: masonryType,
    wallLength: wallLengthM,
    surfaceLength: surfaceLengthM,
    surfaceHeight: surfaceHeightM,
    cornerCount: cornerCount,
    wallThickness: wallThickness
  };

  console.log('[IsoDash Analyse] Calculation input:', calcState);

  var analysis = null;
  try {
    if (window.IsoDash && window.IsoDash.Calculations && typeof window.IsoDash.Calculations.calculateFinalAnalysis === 'function') {
      analysis = window.IsoDash.Calculations.calculateFinalAnalysis(calcState);
      console.log('[IsoDash Analyse] Calculation result:', analysis);
    } else {
      console.warn('[IsoDash Analyse] Calculations engine not available, using raw state');
    }
  } catch (err) {
    console.error('[IsoDash Analyse] Calculation error:', err);
  }

  /* Prepare store update — but DON'T write yet.
     Topbar listens to store changes and would show price/qty
     during the calculation animation. We defer the write until
     the animation is complete and the transition screen appears. */
  var _pendingStoreUpdate = {
    wall: {
      lengthCm: Math.round(wallLengthM * 100),
      wallLengthCm: Math.round(wallLengthM * 100),
      wallHeightCm: Math.round(surfaceHeightM * 100),
      surfaceLengthCm: Math.round(surfaceLengthM * 100),
      surfaceHeightCm: Math.round(surfaceHeightM * 100),
      thicknessCm: wallThickness,
      wallThicknessCm: wallThickness,
      masonry: masonryType,
      corners: cornerCount
    },
    diagnosis: {
      type: moistureType === 'bottom' ? 'kapillar' : (moistureType === 'side' ? 'drueckend' : 'kapillar'),
      confidence: 86,
      flags: { moistureType: moistureType },
      moistureType: moistureType
    }
  };

  if (analysis) {
    var resolvedLengthCm = Math.round((analysis.wallLengthM || wallLengthM) * 100);
    _pendingStoreUpdate.wall.lengthCm = resolvedLengthCm;
    _pendingStoreUpdate.wall.wallLengthCm = resolvedLengthCm;
  }

  /* ── 2b. Preload modules during animation (~7s window) ──
     Priority:
       1) Übersicht first (target route after transition)
       2) Remaining modules in defined business order */
  try {
    if (window.IsoDashShell && typeof IsoDashShell.importRouteModule === 'function') {
      var _firstRoute = 'uebersicht';
      var _backgroundOrder = ['wirkung','machbar','kosten','bohrplan','zeit','garantie','trouble'];
      var _idle = window.requestIdleCallback || function(fn){ setTimeout(fn, 80); };
      var _idx = 0;

      var _loadBackgroundNext = function() {
        if (_idx >= _backgroundOrder.length) return;
        var rid = _backgroundOrder[_idx++];
        IsoDashShell.importRouteModule(rid)
          .catch(function() {})
          .then(function() { _idle(_loadBackgroundNext); }, function() { _idle(_loadBackgroundNext); });
      };

      var _startBackground = function() {
        _idle(_loadBackgroundNext);
      };

      /* Ensure overview fetch starts and settles first */
      IsoDashShell.importRouteModule(_firstRoute).then(_startBackground, _startBackground);
    }
  } catch(_preloadErr) {}

  /* ── 3. Animate the loading checklist (~7s), then commit store & show transition ── */
  animateCalculationSteps().then(function () {
    /* NOW write the store — topbar updates only after animation is done */
    if (_storeRef && typeof _storeRef.set === 'function') {
      _storeRef.set(_pendingStoreUpdate);
      console.log('[IsoDash Analyse] Store updated (post-animation):', _pendingStoreUpdate);
    }
    window.logr3Track && window.logr3Track("isodash-berechnung-fertig", { step: true });
    if (_mounted) {
      renderTransitionScreen();
    }
  });
}


/* ══════════════════════════════════════════════════════════════
   ═══ TRANSITION SCREEN (between data entry and dashboard) ═══
   Zeigt Zusammenfassung der Eingaben + Garantie-Botschaft.
   CTA führt zur Übersichtsseite.
   ══════════════════════════════════════════════════════════════ */

function renderTransitionScreen() {
  _flowPhase = 'transition';
  /* Globales Flag: Speichern-Button (Mobile-Header) darf jetzt erscheinen,
     weil Sanierungsplan freigegeben ist. */
  try { window._isodashSaveAvailable = true; } catch(_) {}
  if (window.IsoDash && typeof window.IsoDash.renderTopbarData === 'function') {
    try { window.IsoDash.renderTopbarData(); } catch(_) {}
  }
  if (!_rootEl) return;
  /* Flag JETZT setzen (localStorage) — damit bei Rückkehr zur Analyse-Seite
     renderReturnScreen() aufgerufen wird statt erneut die Transition. */
  try { localStorage.setItem('isodash_transition_shown', '1'); } catch(_e) {}

  var S = _sharedState;

  /* Daten für Chips auslesen */
  var wallLenM = S.wallLengthM || (S.wallLengthCm ? (S.wallLengthCm / 100) : 0);
  var heightCm = S.surfaceHeightCm || (S.surfaceHeightM ? Math.round(S.surfaceHeightM * 100) : 0);
  var wallLevel = S.wallLevel || S.lage || 'eg';
  var masonryType = S.masonryType || 'ziegel';
  var masonryLabel = S.masonryLabel || _getMasonryLabel(masonryType);
  var wallThick = parseInt(S.wallThickness, 10) || 36;
  var corners = parseInt(S.cornerCount, 10) || 0;
  var moistureType = S.moistureType || 'bottom';
  var barrierLabel = moistureType === 'side' ? 'Fl\u00e4chenabdichtung' : 'Horizontalsperre';

  /* SSOT-Daten von getFinalAnalysis() */
  var analysis = null;
  try {
    if (window.IsoDash && window.IsoDash.Calculations && typeof window.IsoDash.Calculations.getFinalAnalysis === 'function') {
      analysis = window.IsoDash.Calculations.getFinalAnalysis();
    }
  } catch(_e) {}

  var bottles = (analysis && analysis.calculatedBottles) || 0;
  var holes = (analysis && analysis.holeCount) || 0;
  var totalPrice = (analysis && analysis.totalPriceIsofin) || 0;
  var workTimeShort = (analysis && analysis.workTimeTextShort) || '';
  var difficulty = (analysis && analysis.difficultyScore) || 0;
  var diffLabel = (analysis && analysis.difficultyLabel) || '';

  /* Format helpers */
  var lenStr = wallLenM ? (wallLenM % 1 === 0 ? wallLenM.toFixed(0) : wallLenM.toFixed(1).replace('.', ',')) + '\u00A0m' : '\u2013';
  var heightStr = heightCm ? heightCm + '\u00A0cm' : '\u2013';
  var thickStr = wallThick + '\u00A0cm';
  var cornerStr = corners === 0 ? 'Keine Ecken' : corners + (corners === 1 ? ' Ecke' : ' Ecken');
  var priceStr = totalPrice ? totalPrice.toLocaleString('de-DE') + '\u00A0\u20ac' : '\u2013';

  /* Difficulty bar (5 blocks) */
  var diffBar = '';
  for (var di = 1; di <= 5; di++) {
    diffBar += di <= difficulty ? '\u2588' : '\u2591';
  }

  /* Ersparnis-Daten aus SSOT */
  var savingsPercent = (analysis && analysis.savingsPercent) || 0;

  _rootEl.innerHTML = ''
    + '<div class="ihub-trans">'

    /* Headline — kein Shield-Icon mehr */
    + '<div class="ihub-trans-icon" style="font-size:48px !important">\u2705</div>'
    + '<div class="ihub-trans-hl">Ihr Sanierungsplan wurde freigegeben.</div>'
    + '<div class="ihub-trans-text">Alle Module sind jetzt verf\u00fcgbar \u2014 Bohrplan, Kosten, Zeitplan und Garantie wurden berechnet.</div>'

    /* SSOT Data Chips — kein Preis, daf\u00fcr Ersparnis */
    + '<div class="ihub-trans-chips">'
    + '<div class="ihub-trans-chip"><span class="ihub-trans-chip-icon">\uD83D\uDEE1\uFE0F</span>' + barrierLabel + '</div>'
    + '<div class="ihub-trans-chip"><span class="ihub-trans-chip-icon">\uD83E\uDDF1</span>' + masonryLabel + ', ' + thickStr + '</div>'
    + (bottles ? '<div class="ihub-trans-chip"><span class="ihub-trans-chip-icon" style="display:inline-flex !important;align-items:center !important;justify-content:center !important;width:16px !important;height:16px !important"><img src="https://cdn.shopify.com/s/files/1/0846/5550/5691/files/2025-01-18-Isofin_Freimuth_freisteller.jpg?v=1763364228" alt="" style="width:16px !important;height:16px !important;object-fit:contain !important;border-radius:2px !important"></span>' + bottles + ' Flaschen</div>' : '')
    + (holes ? '<div class="ihub-trans-chip"><span class="ihub-trans-chip-icon" style="display:inline-flex !important;align-items:center !important;justify-content:center !important;width:16px !important;height:16px !important"><svg width="14" height="14" viewBox="0 0 16 16" style="display:block !important"><circle cx="8" cy="8" r="6" fill="none" stroke="#8A8681" stroke-width="1.5"/><circle cx="8" cy="8" r="2" fill="#8A8681"/></svg></span>' + holes + ' Bohrl\u00f6cher</div>' : '')
    + (workTimeShort ? '<div class="ihub-trans-chip"><span class="ihub-trans-chip-icon">\u23F1</span>' + workTimeShort + '</div>' : '')
    + (savingsPercent > 0 ? '<div class="ihub-trans-chip ihub-trans-chip--savings"><span class="ihub-trans-chip-icon">\uD83D\uDCAA</span>' + savingsPercent + '\u00A0% g\u00fcnstiger \u2014 selber machen &amp; sparen</div>' : '')
    + '</div>'

    /* Difficulty Teaser */
    + (difficulty ? '<div class="ihub-trans-diff" style="text-align:center !important;font-size:13px !important;color:var(--ds-text-muted) !important;margin-bottom:20px !important">\uD83C\uDFAF Schwierigkeit: <span style="letter-spacing:2px !important;color:var(--ds-text-bright) !important">' + diffBar + '</span> ' + difficulty + ' von 5' + (diffLabel ? ' \u2014 ' + diffLabel : '') + '</div>' : '')

    /* CTA — jetzt VOR der Garantie-Box (sticky am Bottom auf Mobile) */
    + '<div class="ihub-trans-cta-wrap">'
    + '<button class="ihub-trans-cta" data-trans-cta>'
    +   '<span class="ihub-trans-cta-main">Ergebnisse ansehen <span class="ihub-entry-cta-arrow cta-arrow">\u2192</span></span>'
    +   '<span class="ihub-trans-cta-sub">Basierend auf Ihren Eingaben individuell f\u00fcr Sie berechnet</span>'
    + '</button>'
    /* Ladebalken unter CTA wurde entfernt — User fand die Linie störend */
    + '</div>' // .ihub-trans-cta-wrap

    /* Guarantee Box — unter CTA, subtiler */
    + '<div class="ihub-trans-guarantee" style="margin-top:16px !important;padding:16px 18px !important;opacity:.85 !important">'
    + '<div class="ihub-trans-guarantee-head">'
    + '<span class="ihub-trans-guarantee-icon">\uD83D\uDEE1\uFE0F</span>'
    + '<span class="ihub-trans-guarantee-title">Lebenslange garantierte Wirkung</span>'
    + '</div>'
    + '<div class="ihub-trans-guarantee-text">Wenn Sie den berechneten Bohrplan befolgen, geben wir Ihnen die Sicherheit, dass die Hydrophobierung korrekt ausgef\u00fchrt wird \u2014 inklusive lebenslanger Wirksamkeitsgarantie.</div>'
    + '</div>'

    /* Trust Footer */
    + '<div class="ihub-trans-trust">'
    + '<div class="ihub-trans-trust-item"><img src="https://cdn.shopify.com/s/files/1/0846/5550/5691/files/tuev-isofin-250px.jpg?v=1780998710" alt="T\u00dcV" class="ihub-trans-trust-logo"><span>T\u00dcV gepr\u00fcft</span></div>'
    + '<div class="ihub-trans-trust-item"><img src="https://cdn.shopify.com/s/files/1/0846/5550/5691/files/gempages_549688892727493681-5c62.webp" alt="DHBV" class="ihub-trans-trust-logo"><span>DHBV Mitglied</span></div>'
    + '<div class="ihub-trans-trust-item"><img src="https://cdn.shopify.com/s/files/1/0846/5550/5691/files/gempages_549688892727493681-45bf.webp" alt="MPA NRW" class="ihub-trans-trust-logo"><span>MPA NRW</span></div>'
    + '</div>'

    + '</div>'; /* /ihub-trans */

  /* CTA — Klick schaltet Sidebar frei + navigiert zur Übersicht */
  function goToUebersicht() {
    try {
      if (window.ID && typeof window.ID.unlockModules === 'function') {
        window.ID.unlockModules();
      }
    } catch(_e) {}
    if (_navigateRef && _mounted) {
      try { document.body.style.overflow = ''; } catch(_e) {}
      _navigateRef('uebersicht');
    }
  }

  var ctaBtn = _rootEl.querySelector('[data-trans-cta]');
  if (ctaBtn) {
    ctaBtn.addEventListener('click', goToUebersicht);
  }

  /* Ladebalken — Animation ohne Auto-Weiterleitung (User klickt selbst) */
  var progressBar = _rootEl.querySelector('[data-trans-bar]');
  if (progressBar) {
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        progressBar.style.width = '100%';
      });
    });
  }

  /* Scroll to top */
  var ct = document.getElementById('ct');
  if (ct) { try { ct.scrollTo({ top: 0, behavior: 'smooth' }); } catch(_e) { ct.scrollTop = 0; } }
}

/* ══════════════════════════════════════════════════════════════
   ═══ RETURN SCREEN (zweiter Besuch, Berechnung existiert) ═══
   ══════════════════════════════════════════════════════════════ */

function renderReturnScreen() {
  _flowPhase = 'return';
  /* Globales Flag: Speichern-Button im Header darf jetzt erscheinen */
  try { window._isodashSaveAvailable = true; } catch(_) {}
  if (window.IsoDash && typeof window.IsoDash.renderTopbarData === 'function') {
    try { window.IsoDash.renderTopbarData(); } catch(_) {}
  }
  if (!_rootEl) return;

  /* Daten auslesen */
  var analysis = null;
  try {
    if (window.IsoDash && window.IsoDash.Calculations && typeof window.IsoDash.Calculations.getFinalAnalysis === 'function') {
      analysis = window.IsoDash.Calculations.getFinalAnalysis();
    }
  } catch(_e) {}

  var bottles = (analysis && analysis.calculatedBottles) || 0;
  var totalPrice = (analysis && analysis.totalPriceIsofin) || 0;
  var priceStr = totalPrice ? totalPrice.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '\u00a0\u20ac' : '';

  _rootEl.innerHTML = ''
    + '<div class="ihub-mc" style="display:flex !important;flex-direction:column !important;height:100% !important">'
    /* Content-Bereich (zentriert) */
    + '<div style="flex:1 !important;display:flex !important;flex-direction:column !important;align-items:center !important;justify-content:center !important;text-align:center !important;padding:32px 20px 80px !important">'

    + '<div style="font-size:48px !important;margin-bottom:16px !important">\u2705</div>'
    + '<div style="font-size:20px !important;font-weight:700 !important;color:var(--ds-text) !important;margin-bottom:8px !important;line-height:1.3 !important">Ihre Berechnung ist aktiv</div>'
    + '<div style="font-size:14px !important;color:var(--ds-text-muted) !important;line-height:1.6 !important;margin-bottom:24px !important;max-width:420px !important">Ihr Sanierungsplan mit allen Modulen wurde bereits freigegeben.'
    + (bottles ? ' ' + bottles + ' Flaschen' : '')
    + (priceStr ? ' f\u00fcr ' + priceStr : '')
    + ' berechnet.</div>'

    /* Kalkulation neu starten — im Content (sekundär) */
    + '<button data-return="reset" style="display:inline-flex !important;align-items:center !important;gap:6px !important;padding:10px 20px !important;background:transparent !important;border:1px solid var(--ds-border) !important;border-radius:8px !important;color:var(--ds-text-muted) !important;font-size:13px !important;cursor:pointer !important;font-family:inherit !important">'
    + '\u21BB Kalkulation neu starten</button>'

    + '</div>'
    /* Sticky-Footer: Sanierungsplan ansehen (volle Breite, primary CTA) */
    + '<div class="ihub-mc-result-foot" style="flex-shrink:0 !important;background:var(--ds-bg) !important;border-top:1px solid var(--ds-border) !important;padding:14px 16px calc(14px + env(safe-area-inset-bottom,0px)) !important">'
    + '<button data-return="uebersicht" style="display:flex !important;align-items:center !important;justify-content:center !important;gap:10px !important;width:100% !important;max-width:480px !important;margin:0 auto !important;padding:16px 24px !important;background:linear-gradient(180deg,#D6001C 0%,#A80016 100%) !important;color:#fff !important;border:none !important;border-radius:14px !important;font-family:inherit !important;font-size:17px !important;font-weight:700 !important;cursor:pointer !important;box-shadow:0 6px 16px rgba(214,0,28,.35),0 3px 6px rgba(0,0,0,.2),inset 0 -2px 0 rgba(0,0,0,.15) !important;letter-spacing:.3px !important;white-space:nowrap !important">'
    + 'Sanierungsplan ansehen <span class="ihub-entry-cta-arrow cta-arrow">\u2192</span>'
    + '</button>'
    + '</div>'
    + '</div>';

  /* Event delegation */
  _rootEl.addEventListener('click', _returnClickHandler);

  /* Scroll to top */
  var ct = document.getElementById('ct');
  if (ct) { try { ct.scrollTo({ top: 0, behavior: 'smooth' }); } catch(_e) { ct.scrollTop = 0; } }
}

function _returnClickHandler(e) {
  var btn = e.target.closest('[data-return]');
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();
  var action = btn.getAttribute('data-return');
  _rootEl.removeEventListener('click', _returnClickHandler);

  if (action === 'uebersicht') {
    try {
      if (window.ID && typeof window.ID.unlockModules === 'function') {
        window.ID.unlockModules();
      }
    } catch(_e) {}
    if (_navigateRef && _mounted) {
      _navigateRef('uebersicht');
    }
  } else if (action === 'reset') {
    window.logr3Track && window.logr3Track('isodash-reset', { step: true });
    clearFlowState();
    if (_storeRef && typeof _storeRef.set === 'function') {
      _storeRef.set({});
    }
    /* Shopify-Warenkorb auch leeren — fail-safe: reload immer */
    var didReload = false;
    function _safeReload(){ if(didReload)return; didReload=true; try{location.reload();}catch(_){window.location.href=window.location.pathname;} }
    try {
      if (typeof fetch === 'function') {
        fetch('/cart/clear.js', { method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json'} })
          .then(_safeReload, _safeReload);
        setTimeout(_safeReload, 1500);
      } else {
        setTimeout(_safeReload, 200);
      }
    } catch (_) { setTimeout(_safeReload, 200); }
  }
}


/* Masonry label helper */
function _getMasonryLabel(type) {
  var labels = {
    'ziegelstein': 'Ziegelstein',
    'ziegel': 'Ziegelstein',
    'kalksandstein': 'Kalksandstein',
    'naturstein': 'Naturstein',
    'hohlblockziegel': 'Hohlblock',
    'hohlblock': 'Hohlblock',
    'beton': 'Beton',
    'unsicher': 'Nicht bestimmt'
  };
  return labels[type] || type || 'Nicht bestimmt';
}


/* ═══ SCRIPT LOADING ═══ */
function loadReactIfNeeded() {
  if (window.React && window.ReactDOM) return Promise.resolve();
  /* React + ReactDOM parallel laden */
  var promises = [];
  if (!window.React) promises.push(loadScript(REACT_CDN, false));
  if (!window.ReactDOM) promises.push(loadScript(REACT_DOM_CDN, false));
  return Promise.all(promises);
}

var STEP_ID_TO_FILE = {
  'step-0': 'dashboard-step-0.js',
  'step-1': 'dashboard-step-1.js',
  'step-2': 'dashboard-step-2.js',
  'step-3': 'dashboard-step-3.js'
};

function loadStepFile(indexOrId) {
  var file;
  if (typeof indexOrId === 'string') {
    file = STEP_ID_TO_FILE[indexOrId];
  } else {
    file = STEP_FILES[indexOrId];
  }
  if (!file) return Promise.resolve();
  if (window.IsoDash && window.IsoDash.__loaded && window.IsoDash.__loaded[file]) return Promise.resolve();
  var base = getAssetBase();
  return loadScript(base + file, true);
}

/**
 * FAST PATH: React + ersten Step parallel laden → sofort rendern.
 * Restliche Steps werden im Hintergrund nachgeladen.
 * Lädt den AKTUELLEN Step (kann ungleich step-1 sein, wenn übersprungen).
 */
function loadFirstStepFast() {
  var firstStepId = STEP_ORDER[_currentStepIndex] || STEP_ORDER[0];
  return Promise.all([
    loadReactIfNeeded(),
    loadStepFile(firstStepId)
  ]);
}

function preloadRemainingSteps() {
  /* Steps 1–3 sequentiell im Hintergrund nachladen */
  var chain = Promise.resolve();
  for (var i = 1; i < STEP_FILES.length; i++) {
    (function (idx) {
      chain = chain.then(function () {
        return loadStepFile(idx).catch(function (err) {
          console.warn('[IsoDash Analyse] Preload step ' + idx + ' failed:', err);
        });
      });
    })(i);
  }
  return chain;
}

/**
 * Stellt sicher, dass der Step für den aktuellen Index geladen ist.
 * Wird aufgerufen bevor ein Step gerendert wird (falls User schneller klickt als Preload).
 */
function ensureCurrentStepLoaded() {
  var stepId = STEP_ORDER[_currentStepIndex];
  return loadStepFile(stepId);
}

/**
 * FA2 Scripts laden: Content + SSOT Diagnose Engine.
 * Nur geladen bei Bedarf (wenn User "unsicher" wählt).
 */
function loadFA2Scripts() {
  if (window.FA_CONTENT && window.FA_SSOT) return Promise.resolve();
  var base = getAssetBase();
  return Promise.all(FA2_FILES.map(function(f) {
    return loadScript(base + f, true);
  }));
}

/* ═══ LOADING UI ═══ */
function renderLoading(root) {
  root.innerHTML = ''
    + '<div style="text-align:center !important;padding:52px 24px !important">'
    + '<div style="font-size:40px !important;margin-bottom:16px !important">\uD83D\uDD0D</div>'
    + '<div style="font-size:18px !important;font-weight:700 !important;color:var(--ds-text) !important;margin-bottom:8px !important">Feuchtigkeits-Analyse</div>'
    + '<div style="font-size:13px !important;color:var(--ds-text-muted) !important;line-height:1.6 !important;max-width:440px !important;margin:0 auto 20px !important">'
    + 'Analyse-Module werden geladen\u2026</div>'
    + '<div style="width:40px !important;height:40px !important;margin:0 auto !important;border:3px solid rgba(255,255,255,.1) !important;border-top-color:#D6001C !important;border-radius:50% !important;animation:isodash-analyse-spin 1s linear infinite !important"></div>'
    + '</div>';

  /* Spinner-Animation injizieren */
  if (!document.getElementById('isodash-analyse-spin-css')) {
    var s = document.createElement('style');
    s.id = 'isodash-analyse-spin-css';
    s.textContent = '@keyframes isodash-analyse-spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}';
    document.head.appendChild(s);
  }
}

function renderError(root, message) {
  root.innerHTML = ''
    + '<div style="text-align:center !important;padding:52px 24px !important">'
    + '<div style="font-size:40px !important;margin-bottom:16px !important">\u26A0\uFE0F</div>'
    + '<div style="font-size:18px !important;font-weight:700 !important;color:var(--ds-text) !important;margin-bottom:8px !important">Analyse konnte nicht geladen werden</div>'
    + '<div style="font-size:13px !important;color:var(--ds-text-muted) !important;line-height:1.6 !important;max-width:440px !important;margin:0 auto !important">'
    + (message || 'Bitte laden Sie die Seite neu.') + '</div>'
    + '</div>';
}


/* ══════════════════════════════════════════════════════════════
   ═══ ENTRY SCREEN ═══
   Hero + Feature-Chips + CTA → Step 0 Kapillar-Vorqualifizierung
   ══════════════════════════════════════════════════════════════ */

function renderEntryScreen(root) {
  _flowPhase = 'entry';
  /* Tracking: Page-View der Analyse-Entry-Seite (Welcome-Screen vor Wizard-Start) */
  try { window.logr3Track && window.logr3Track('isodash-analyse-entry-view', { step: true }); } catch(_) {}
  /* Header-Save-Button verstecken — wird erst nach "Sanierungsplan freigegeben" sichtbar */
  try { window._isodashSaveAvailable = false; } catch(_) {}
  if (window.IsoDash && typeof window.IsoDash.renderTopbarData === 'function') {
    try { window.IsoDash.renderTopbarData(); } catch(_) {}
  }

  /* P6: Welcome-Back-Banner — wird gezeigt wenn alte Berechnung im Storage liegt
     (>1h alt, <30 Tage, noch nicht gekauft, Banner nicht in dieser Session dismissed). */
  var resumeBanner = '';
  try {
    var calc = window.IsoDash && window.IsoDash.Calculations;
    var a = (calc && typeof calc.getFinalAnalysis === 'function') ? calc.getFinalAnalysis() : null;
    var hasA = a && Number(a.calculatedBottles) > 0 && Number(a.totalPriceIsofin) > 0;
    var dismissed = false;
    try { dismissed = sessionStorage.getItem('isodash_resume_dismissed') === '1'; } catch(_) {}
    var a2cDone = false;
    try { a2cDone = localStorage.getItem('isodash_a2c_done') === '1'; } catch(_) {}
    var calcAtRaw = null;
    try { calcAtRaw = localStorage.getItem('isodash_last_calc_at'); } catch(_) {}
    var calcAt = calcAtRaw ? parseInt(calcAtRaw, 10) : 0;
    var nowMs = Date.now();
    var ageMs = calcAt > 0 ? (nowMs - calcAt) : 0;
    var MIN_AGE = 60 * 60 * 1000;
    var MAX_AGE = 30 * 24 * 60 * 60 * 1000;
    var isResume = hasA && !dismissed && !a2cDone && ageMs > MIN_AGE && ageMs < MAX_AGE;
    if (isResume) {
      var bottles = Math.round(a.calculatedBottles);
      var priceTxt = (Number(a.totalPriceIsofin)).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '\u00a0\u20ac';
      var d = (window.IsoDashShell && typeof window.IsoDashShell.tbDerived === 'function')
        ? window.IsoDashShell.tbDerived(window.IsoDash && window.IsoDash.project || {})
        : null;
      var blurb = '';
      if (d && d.hasAnalysis) {
        var num = (d.isSide && d.surfaceAreaM2) ? d.surfaceAreaM2 : d.lengthM;
        var unit = (d.isSide && d.surfaceAreaM2) ? 'm\u00B2' : 'm';
        var label = d.isSide ? 'Fl\u00e4chensperre' : 'Horizontalsperre';
        if (num && isFinite(num)) {
          var numStr = (num % 1 === 0) ? num.toFixed(0) : num.toFixed(1).replace('.', ',');
          blurb = numStr + '\u00a0' + unit + ' ' + label + ' \u00b7 ';
        }
      }
      var ageHours = Math.floor(ageMs / (60 * 60 * 1000));
      var ageDays = Math.floor(ageMs / (24 * 60 * 60 * 1000));
      var when = ageDays >= 1
        ? (ageDays === 1 ? 'gestern' : 'vor ' + ageDays + ' Tagen')
        : (ageHours <= 1 ? 'vor 1 Stunde' : 'vor ' + ageHours + ' Stunden');
      resumeBanner = ''
        + '<div class="ds-resume" id="isodash-resume-banner">'
        + '<div class="ds-resume-icon" aria-hidden="true">\uD83D\uDC4B</div>'
        + '<div class="ds-resume-text">'
        +   '<div class="ds-resume-title">Willkommen zur\u00fcck! Ihre Berechnung von ' + when + ' liegt bereit.</div>'
        +   '<div class="ds-resume-meta">' + blurb + bottles + ' Flaschen \u00b7 ' + priceTxt + '</div>'
        + '</div>'
        + '<div class="ds-resume-actions">'
        +   '<button type="button" class="ds-resume-btn-primary" data-resume="checkout">\u2192 Direkt zum Checkout</button>'
        +   '<button type="button" class="ds-resume-btn-secondary" data-resume="result">Ergebnisse ansehen</button>'
        + '</div>'
        + '<button type="button" class="ds-resume-close" data-resume="close" aria-label="Banner schlie\u00dfen" title="Schlie\u00dfen">\u00d7</button>'
        + '</div>';
    }
  } catch(_) {}

  root.innerHTML = ''
    + '<div class="ihub-entry">'
    + resumeBanner

    + '<div class="ihub-entry-eyebrow">Bedarfsrechner f\u00fcr Ihre<br>Mauerwerksabdichtung</div>'
    + '<div class="ihub-entry-hl">Wie viele Isofin\u00ae-Flaschen brauchen Sie wirklich?</div>'
    + '<div class="ihub-entry-sub">Finden Sie es in nur 2 Minuten heraus \u2013 inklusive Bohrplan, Kostenaufschl\u00fcsselung und lebenslanger Wirksamkeitsgarantie f\u00fcr eine vollst\u00e4ndige Sanierung Ihres Feuchtigkeitsschadens.</div>'

    /* CTA with subline */
    + '<button class="ihub-entry-cta" data-entry-cta>'
    + '<span class="ihub-entry-cta-content">'
    + '<span class="ihub-entry-cta-main">Jetzt Berechnung starten <span class="ihub-entry-cta-arrow">\u2192</span></span>'
    + '<span class="ihub-entry-cta-sub ihub-entry-cta-sub--desktop">Ergebnis sofort \u00b7 kostenlos \u00b7 keine Registrierung</span>'
    + '<span class="ihub-entry-cta-sub ihub-entry-cta-sub--mobile">'
    + '<span class="ihub-cta-rotate-item ihub-cta-r1">Ergebnis sofort</span>'
    + '<span class="ihub-cta-rotate-item ihub-cta-r2">Kostenlos \u00b7 keine Registrierung</span>'
    + '</span>'
    + '</span>'
    + '</button>'

    /* Ergebnis-Vorschau als Akkordeon */
    + '<details class="ihub-entry-acc">'
    + '<summary class="ihub-entry-acc-summary">Nach der Berechnung schalten wir Ihnen Ihren pers\u00f6nlichen Sanierungsplan frei mit: <span class="ih-acc-icon"><svg viewBox="0 0 12 12"><polyline points="2,4 6,8 10,4"/></svg></span></summary>'
    + '<div class="ihub-entry-acc-content">'
    + '<div class="ihub-entry-chips">'
    + '<div class="ihub-entry-chip"><span class="ihub-entry-chip-icon">\uD83D\uDCCA</span>Machbarkeit Ihrer Abdichtung</div>'
    + '<div class="ihub-entry-chip"><span class="ihub-entry-chip-icon">\uD83D\uDCB0</span>Kosten & Vergleich zur Fachfirma</div>'
    + '<div class="ihub-entry-chip"><span class="ihub-entry-chip-icon">\uD83D\uDCD0</span>Bohrplan & Materialempfehlung</div>'
    + '<div class="ihub-entry-chip"><span class="ihub-entry-chip-icon">\uD83D\uDD2C</span>Wirkung & Labornachweis</div>'
    + '<div class="ihub-entry-chip"><span class="ihub-entry-chip-icon">\uD83D\uDCA8</span>Trocknungs-Guide (bis zu 3\u00d7 schneller trocknen)</div>'
    + '<div class="ihub-entry-chip"><span class="ihub-entry-chip-icon">\uD83D\uDEE1\uFE0F</span>Garantie & Absicherung</div>'
    + '</div>'
    + '</div>'
    + '</details>'

    /* Trust Line */
    /* Trust-Zeile entfernt */

    + '</div>'; /* /ihub-entry */

  /* Event delegation */
  root.addEventListener('click', _entryClickHandler);

  /* Browser-History: pushState */
  if (window.history && window.history.pushState) {
    window.history.pushState({ isodashStep: 'entry' }, '');
  }

  /* Scroll to top */
  var ct = document.getElementById('ct');
  if (ct) { try { ct.scrollTo({ top: 0, behavior: 'smooth' }); } catch(_e) { ct.scrollTop = 0; } }
}

function _entryClickHandler(e) {
  /* P6: Welcome-Back-Banner Click-Handler */
  var resumeBtn = e.target.closest('[data-resume]');
  if (resumeBtn) {
    var action = resumeBtn.getAttribute('data-resume');
    var banner = document.getElementById('isodash-resume-banner');
    if (action === 'close') {
      try { sessionStorage.setItem('isodash_resume_dismissed', '1'); } catch(_) {}
      if (banner && banner.parentNode) banner.parentNode.removeChild(banner);
      return;
    }
    if (action === 'checkout') {
      if (window.ID && typeof window.ID.cart === 'function') {
        window.ID.cart('isodash-resume-checkout');
      }
      return;
    }
    if (action === 'result') {
      if (window.ID && typeof window.ID.go === 'function') {
        window.ID.go('uebersicht');
      }
      return;
    }
  }

  var cta = e.target.closest('[data-entry-cta]');
  if (cta) {
    _rootEl.removeEventListener('click', _entryClickHandler);
    /* Automatischer Reset aller Variablen + Berechnungsdaten
       damit eine frische Analyse bei Null startet */
    clearFlowState();
    try {
      if (window.IsoDash && window.IsoDash.Calculations && typeof window.IsoDash.Calculations.clearAnalysis === 'function') {
        window.IsoDash.Calculations.clearAnalysis();
      }
    } catch(_) {}
    try { window._isodashSaveAvailable = false; } catch(_) {}
    /* Topbar sofort refreshen → Sanierungspaket/CTA im Header ausblenden */
    if (window.IsoDash && typeof window.IsoDash.renderTopbarData === 'function') {
      try { window.IsoDash.renderTopbarData(); } catch(_) {}
    }
    setFlowState('isodash_analysis_source', 'dashboard');
    window.logr3Track && window.logr3Track("isodash-analyse-start", { step: true });
    renderStep0Capillary(_rootEl);
    return;
  }
}


/* ══════════════════════════════════════════════════════════════
   ═══ STEP 0: KAPILLAR-VORQUALIFIZIERUNG ═══
   Fragt ob der Nutzer Kapillarfeuchtigkeit erkennt.
   "Ja" → Wall Wizard,  "Unsicher" → FA2 inline
   ══════════════════════════════════════════════════════════════ */

function renderStep0Capillary(root) {
  _flowPhase = 'step0-capillary';
  setFlowState('isodash_flow_phase', 'step0-capillary');
  /* Tracking: Page-View der Kapillarfeuchtigkeit-Prüfung (Step 0) */
  try { window.logr3Track && window.logr3Track('isodash-kapillar-view', { step: true }); } catch(_) {}

  /* Wizard-CSS laden (falls noch nicht da) */
  if (!document.getElementById('isodash-wizard-css')) {
    var wl = document.createElement('link');
    wl.id = 'isodash-wizard-css';
    wl.rel = 'stylesheet';
    wl.href = vUrl((window.ISODASH_ASSET_BASE || './') + 'isodash-wizard.css');
    document.head.appendChild(wl);
  }

  var _mob = window.innerWidth < 768;
  /* Freigabe-Checklist global rendern */
  var _freigabeHtml = '';
  if (window.IsoDashUtils && typeof IsoDashUtils.renderFreigabeChecklist === 'function') {
    _freigabeHtml = IsoDashUtils.renderFreigabeChecklist(0);
  }
  root.innerHTML = ''
    + '<div id="isodash-wiz-step0-root">'
    + '<div class="s2-layout">'

    /* ── LEFT COLUMN (identische Struktur wie Step 0/1) ── */
    + '<div class="s2-left">'
    +   '<div class="wiz-peek-bar" data-action="toggle-drawer"><div class="wiz-peek-text"><span>\uD83D\uDD0D</span>Typische Anzeichen</div><div class="wiz-peek-handle"></div><button type="button" class="wiz-peek-close" data-action="close-drawer">\u2715</button></div>'
    +   '<div class="wiz-left-slider-wrap">'
    +     '<div class="wiz-left-slider" data-left-slider>'
    +       '<div class="wiz-left-page" data-left-main>'
    +         '<div class="wiz-left-label"></div>'
    +         '<h1 class="wiz-left-hl">Haben Sie eines der<br><span class="red">folgenden Anzeichen?</span></h1>'
    +         '<p class="wiz-left-sub">Isofin\u00ae hilft bei <strong>kapillarer Feuchtigkeit</strong> \u2014 also bei Wasser, das aus dem Boden durch die Poren im Mauerwerk aufsteigt.</p>'

    /* Typische Anzeichen */
    +         '<div class="s0-signs-block">'
    +         '<div class="s0-signs-title">Typische Anzeichen kapillarer Feuchtigkeit:</div>'
    +         '<ul class="s0-signs-list">'
    +         '<li><span class="s0-dot"></span>Feuchte Flecken im unteren Wandbereich</li>'
    +         '<li><span class="s0-dot"></span>Feuchte Kellerw\u00e4nde oder Sockelzonen</li>'
    +         '<li><span class="s0-dot"></span>Wei\u00dfe Ausbl\u00fchungen (Salpeter)</li>'
    +         '<li><span class="s0-dot"></span>Muffiger Geruch im Keller</li>'
    +         '<li><span class="s0-dot"></span>Abplatzender oder br\u00f6selnder Putz</li>'
    +         '</ul>'
    +         '</div>'

    /* Freigabe-Prüfprozess (global) */
    +         '<div class="wiz-freigabe-slot">' + _freigabeHtml + '</div>'

    +       '</div>'
    +       '<div class="wiz-left-page" data-left-detail-page>'
    +         '<div class="wiz-left-detail" data-left-detail>'
    +           '<div class="wiz-detail-sticky-header">'
    +             '<button type="button" class="wiz-left-detail-back" data-action="left-back">\u2190 Zur\u00FCck</button>'
    +           '</div>'
    +           '<div class="wiz-left-detail-h" data-left-detail-title></div>'
    +           '<div class="wiz-left-detail-text" data-left-detail-text></div>'
    +           '<div class="wiz-left-gallery" data-left-gallery></div>'
    +           '<button type="button" class="wiz-left-detail-back wiz-left-detail-back-end" data-action="left-back">\u2190 Zur\u00FCck</button>'
    +         '</div>'
    +       '</div>'
    +     '</div>'
    +   '</div>'
    + '</div>'

    /* ── RIGHT COLUMN (card — wiz-card-* einheitlich f\u00fcr alle Steps) ── */
    + '<div class="s2-right">'
    + '<div class="step1-box wiz-card">'

    /* Header (einheitlich f\u00fcr ALLE Steps) */
    + '<div class="wiz-card-hdr">'
    +   '<button type="button" class="wiz-card-back" data-action="back">\u2190</button>'
    +   '<div class="wiz-card-titlewrap"><div class="wiz-card-title">Kapillarpr\u00fcfung</div><div class="wiz-card-step">Schritt 1 von 5</div></div>'
    +   '<button type="button" class="wiz-card-close" data-action="exit-to-entry">\u2715</button>'
    + '</div>'

    /* Content */
    + '<div class="step1-content wiz-card-body">'

    /* Question */
    +   '<h2 class="wiz-card-q">Ist Ihr Schaden kapillare Feuchtigkeit?</h2>'
    +   '<p class="wiz-card-qsub" style="font-size:13px !important;text-align:center !important;margin:0 0 16px 0 !important;display:block !important;color:var(--ds-text-dim) !important"><span class="rk-arrow-bounce">\u2193</span> Bitte ausw\u00e4hlen <span class="rk-arrow-bounce">\u2193</span></p>'

    /* Options */
    +   '<div class="step1-options">'
    +     '<div class="step1-main-options">'

    +     '<button type="button" class="step1-option-btn s0-yes" data-s0="yes">'
    +       '<span class="step1-option-icon s0-icon-check">\u2714</span>'
    +       '<span class="step1-option-main" lang="de">Kapillar&shy;feuchtigkeit</span>'
    +     '</button>'

    +     '<button type="button" class="step1-option-btn s0-unsure" data-s0="unsure">'
    +       '<span class="step1-option-icon s0-icon-q">?</span>'
    +       '<span class="step1-option-main">Bin mir unsicher</span>'
    +       '<span class="step1-option-sub">Kurzanalyse starten</span>'
    +     '</button>'

    +     '</div>'
    +   '</div>'

    /* Hinweis */
    +   '<p class="step1-hinweis" style="font-size:12px !important;line-height:1.35 !important;margin:4px 0 14px 0 !important">Hinweis: Diese Kalkulation ist f\u00fcr kapillare Mauerwerksfeuchte.</p>'

    /* Hilfestellungen (zwei: kapillar + nicht-kapillar) */
    +   '<div class="wiz-help-section">'
    +     '<div class="wiz-info-accordion-head">Hilfestellungen:</div>'
    +     '<button type="button" class="wiz-info-btn" data-action="left-open" data-info="kapillar"><div class="wiz-info-btn-content"><span class="wiz-info-btn-title">Was ist kapillare Feuchtigkeit?</span><span class="wiz-info-btn-sub">Aufsteigend (Horizontalsperre) + seitlich aus dem Erdreich (Fl\u00e4chensperre).</span></div><span class="wiz-info-btn-arrow">\u2192</span></button>'
    +     '<button type="button" class="wiz-info-btn" data-action="left-open" data-info="unsicher"><div class="wiz-info-btn-content"><span class="wiz-info-btn-title">Was ist KEINE kapillare Feuchtigkeit?</span><span class="wiz-info-btn-sub">Druckwasser, Rohrbruch, Kondens \u2014 inkl. Entscheidungstabelle.</span></div><span class="wiz-info-btn-arrow">\u2192</span></button>'
    +   '</div>'

    /* Back link (mobile) */
    +   '<div class="wiz-mobile-back"><a href="#" data-action="back" class="wiz-back-link">\u2190 Schritt zur\u00FCck</a></div>'

    + '</div>'
    + '</div>'
    + '</div>'

    + '</div>'
    + '<div class="wiz-backdrop" data-action="close-drawer"></div>'

    /* Help overlay (mobile fullscreen) */
    + '<div class="wiz-help-overlay" data-help-overlay>'
    +   '<div class="wiz-help-overlay-inner">'
    +     '<div class="wiz-help-overlay-hdr">'
    +       '<button type="button" data-action="close-help-overlay">\u2190</button>'
    +       '<div class="wiz-help-overlay-hdr-title" data-help-overlay-title>Hilfe</div>'
    +     '</div>'
    +     '<div class="wiz-help-overlay-body">'
    +       '<div class="wiz-left-detail-h" data-help-overlay-detail-title></div>'
    +       '<div class="wiz-left-detail-text" data-help-overlay-text></div>'
    +       '<div class="wiz-left-gallery" data-help-overlay-gallery></div>'
    +       '<div data-help-overlay-select-slot></div>'
    +     '</div>'
    +   '</div>'
    + '</div>'

    + '</div>';

  /* Event delegation */
  root.addEventListener('click', _step0ClickHandler);

  /* Zurück-Links: Kapillarprüfung ist Step 1 (erster Step) → zurück zum Entry-Screen */
  root.querySelectorAll('[data-action="back"]').forEach(function(bl) {
    bl.addEventListener('click', function(e) {
      e.preventDefault();
      _rootEl.removeEventListener('click', _step0ClickHandler);
      renderEntryScreen(_rootEl);
    });
  });
  root.querySelectorAll('[data-action="exit-to-entry"]').forEach(function(xBtn) {
    xBtn.addEventListener('click', function(e) {
      e.preventDefault();
      _rootEl.removeEventListener('click', _step0ClickHandler);
      renderEntryScreen(_rootEl);
    });
  });

  /* ── Hilfestellungen: Left detail + Mobile overlay ── */
  var _s0HelpInfo = {

    /* ============ HILFE 1: KAPILLARE FEUCHTIGKEIT ============ */
    kapillar: {
      title: 'Was ist kapillare Feuchtigkeit?',
      html: '<div class="s0-help-body">'
        + '<p class="s0-help-intro">Kapillare Mauerwerksfeuchtigkeit ist Wasser, das sich \u00fcber die feinen Poren im Mauerwerk verteilt. Sie umfasst <strong>zwei F\u00e4lle</strong> \u2014 beide k\u00f6nnen mit Isofin\u00ae behandelt werden:</p>'

        /* Fall 1: Horizontalsperre */
        + '<div class="s0-help-section">'
        + '<div class="s0-help-section-h">\u2B06\uFE0F 1. Aufsteigende Feuchtigkeit</div>'
        + '<p class="s0-help-section-sub">L\u00f6sung: <strong>Horizontalsperre</strong> \u2014 Wasser steigt aus dem Boden \u00fcber die Wand nach oben</p>'
        + '<ul class="s0-help-list">'
        + '<li>Feuchtigkeit beginnt <strong>unten</strong> an der Wand</li>'
        + '<li>Wand wird nach oben trockener</li>'
        + '<li>Sockelbereich oder unterer Wandbereich feucht</li>'
        + '<li>H\u00e4ufig bei fehlender oder defekter Horizontalsperre</li>'
        + '<li>Typisch bei \u00e4lteren Geb\u00e4uden</li>'
        + '</ul>'
        + '</div>'

        /* Fall 2: Flächensperre */
        + '<div class="s0-help-section">'
        + '<div class="s0-help-section-h">\u27A1\uFE0F 2. Seitlich eindringende Feuchtigkeit</div>'
        + '<p class="s0-help-section-sub">L\u00f6sung: <strong>Fl\u00e4chensperre</strong> \u2014 Wasser dringt durch die Kellerwand aus dem Erdreich</p>'
        + '<ul class="s0-help-list">'
        + '<li>Kellerwand ist <strong>fl\u00e4chig</strong> feucht</li>'
        + '<li>Feuchtigkeit kann auch h\u00f6her als nur unten sein</li>'
        + '<li>Wand grenzt au\u00dfen an Erdreich</li>'
        + '<li>Wasser sickert <strong>langsam und dauerhaft</strong> durch</li>'
        + '<li>Verteilt sich anschlie\u00dfend kapillar im Mauerwerk</li>'
        + '</ul>'
        + '</div>'

        /* Gemeinsame Anzeichen */
        + '<div class="s0-help-section">'
        + '<div class="s0-help-section-h">\u2714\uFE0F Gemeinsame Anzeichen (beide F\u00e4lle)</div>'
        + '<ul class="s0-help-list">'
        + '<li>Wei\u00dfe Ausbl\u00fchungen / Salpeter</li>'
        + '<li>Putz platzt ab oder br\u00f6selt</li>'
        + '<li>Muffiger Geruch</li>'
        + '<li>Wand wirkt k\u00fchl und feucht</li>'
        + '<li>Meist im Keller oder Sockelbereich</li>'
        + '</ul>'
        + '</div>'

        /* Wichtig-Callout */
        + '<div class="s0-help-callout">'
        + '<div class="s0-help-callout-h">Wichtig</div>'
        + '<div class="s0-help-callout-text">Auch wenn Wasser seitlich aus dem Erdreich durch die Kellerwand kommt, verteilt es sich anschlie\u00dfend kapillar im Mauerwerk. Das z\u00e4hlt ebenfalls zu kapillarer Mauerwerksfeuchtigkeit \u2014 und kann mit Isofin\u00ae behandelt werden.</div>'
        + '</div>'

        + '<div class="s0-help-cta-hint">\u2192 Trifft einer der beiden F\u00e4lle zu? Dann k\u00f6nnen Sie mit der Kalkulation fortfahren.</div>'
        + '</div>',
      images: []
    },

    /* ============ HILFE 2: NICHT-KAPILLARE FEUCHTIGKEIT ============ */
    unsicher: {
      title: 'Was ist KEINE kapillare Feuchtigkeit?',
      html: '<div class="s0-help-body">'
        + '<p class="s0-help-intro">Nicht jede feuchte Wand ist kapillare Feuchtigkeit. Wenn Wasser <strong>aktiv</strong> gegen die Wand dr\u00fcckt oder durch die Wand l\u00e4uft, liegt meist Druckwasser oder ein anderer Schaden vor \u2014 dann ist Isofin\u00ae nicht der richtige Weg.</p>'

        /* Druckwasser */
        + '<div class="s0-help-section">'
        + '<div class="s0-help-section-h">\uD83D\uDCA6 1. Druckwasser / stark eindringendes Wasser</div>'
        + '<p class="s0-help-section-sub">Wasser dr\u00fcckt aktiv gegen die Wand oder l\u00e4uft sichtbar durch</p>'
        + '<ul class="s0-help-list">'
        + '<li>Wasser l\u00e4uft an der Wand herunter</li>'
        + '<li>Wand ist sehr nass oder tropft</li>'
        + '<li>Kellerboden kann nass sein oder Wasser steht</li>'
        + '<li>Problem tritt nach <strong>starkem Regen</strong> auf</li>'
        + '<li>Wasser kommt durch Risse, Fugen oder Wand-Boden-Anschluss</li>'
        + '<li>Hanglage oder Wasser sammelt sich au\u00dfen an der Wand</li>'
        + '<li>Feuchtigkeit kommt pl\u00f6tzlich oder sehr stark</li>'
        + '</ul>'
        + '<button type="button" class="s0-help-cta-hint s0-help-cta-hint--alt s0-help-cta-btn" data-s0="unsure">\u2192 Dann bitte Feuchtigkeitsanalyse starten.</button>'
        + '</div>'

        /* Rohrbruch */
        + '<div class="s0-help-section">'
        + '<div class="s0-help-section-h">\uD83D\uDD27 2. Rohrbruch</div>'
        + '<p class="s0-help-section-sub">Lokaler Wasserschaden durch undichte Leitung</p>'
        + '<ul class="s0-help-list">'
        + '<li>Einzelner nasser Fleck</li>'
        + '<li>Pl\u00f6tzlich entstanden</li>'
        + '<li>Bleibt dauerhaft nass</li>'
        + '<li>H\u00e4ufig in Bad, K\u00fcche oder Heizungsraum</li>'
        + '</ul>'
        + '<div class="s0-help-cta-hint" style="color:var(--ds-text-muted) !important;font-style:italic !important;font-size:13px !important">Bei Rohrbruch ist ISOFIN\u00ae nicht einsetzbar \u2014 keine Analyse n\u00f6tig.</div>'
        + '</div>'

        /* Kondenswasser */
        + '<div class="s0-help-section">'
        + '<div class="s0-help-section-h">\u2744\uFE0F 3. Kondenswasser / Schimmel</div>'
        + '<p class="s0-help-section-sub">Feuchtigkeit aus der Raumluft, kein Mauerwerksschaden</p>'
        + '<ul class="s0-help-list">'
        + '<li>Schimmel in Ecken oder hinter M\u00f6beln</li>'
        + '<li>Vor allem im Winter</li>'
        + '<li>L\u00fcften verbessert die Situation</li>'
        + '<li>Keine Salzausbl\u00fchungen</li>'
        + '</ul>'
        + '<button type="button" class="s0-help-cta-hint s0-help-cta-hint--alt s0-help-cta-btn" data-s0="unsure">\u2192 Dann bitte Feuchtigkeitsanalyse starten.</button>'
        + '</div>'

        /* Schnelle Einordnung */
        + '<div class="s0-help-section s0-help-section--table">'
        + '<div class="s0-help-section-h">\uD83D\uDCCB Schnelle Einordnung</div>'
        + '<table class="s0-help-table">'
        + '<thead><tr><th>Situation</th><th>Ursache</th></tr></thead>'
        + '<tbody>'
        + '<tr><td>Wand unten feucht, nach oben trockener</td><td><strong>Kapillar</strong></td></tr>'
        + '<tr><td>Kellerwand fl\u00e4chig feucht</td><td><strong>Kapillar</strong></td></tr>'
        + '<tr><td>Salzausbl\u00fchungen / br\u00f6selnder Putz</td><td><strong>Kapillar</strong></td></tr>'
        + '<tr><td>Wasser tritt durch Wand</td><td>Druckwasser</td></tr>'
        + '<tr><td>Kellerboden nass</td><td>Druckwasser</td></tr>'
        + '<tr><td>Wasser l\u00e4uft au\u00dfen an Wand herunter</td><td>Druckwasser</td></tr>'
        + '<tr><td>Einzelner nasser Fleck</td><td>Rohrbruch</td></tr>'
        + '<tr><td>Schimmel in Ecken</td><td>Kondenswasser</td></tr>'
        + '<tr><td>Unsicher</td><td>Feuchtigkeitsanalyse</td></tr>'
        + '</tbody>'
        + '</table>'
        + '</div>'

        /* Conversion CTA */
        + '<p class="s0-help-result">Wenn Sie sich nicht sicher sind, welche Feuchtigkeitsursache vorliegt, starten Sie bitte die <strong>Feuchtigkeitsanalyse</strong>. Dort pr\u00fcfen wir Schritt f\u00fcr Schritt die Ursache der Feuchtigkeit und geben eine technische Einsch\u00e4tzung.</p>'
        + '<button type="button" class="s0-help-cta-hint s0-help-cta-hint--alt s0-help-cta-btn" data-s0="unsure">\u2192 Feuchtigkeitsanalyse starten</button>'
        + '</div>',
      images: []
    }
  };

  var leftSlider = root.querySelector('[data-left-slider]');
  var detailTitle = root.querySelector('[data-left-detail-title]');
  var detailText = root.querySelector('[data-left-detail-text]');
  var detailGallery = root.querySelector('[data-left-gallery]');

  function setLeftView(isDetail) {
    if (leftSlider) leftSlider.classList.toggle('is-detail', !!isDetail);
  }

  function renderS0LeftDetail(kind) {
    var data = _s0HelpInfo[kind];
    if (!data) return;
    if (detailTitle) detailTitle.textContent = data.title || '';
    if (detailText) detailText.innerHTML = data.html || '';
    if (detailGallery) {
      var imgs = Array.isArray(data.images) ? data.images : [];
      var h = '';
      for (var i = 0; i < imgs.length; i++) {
        h += '<div class="wiz-left-gallery-item"><img class="wiz-left-gallery-img" src="' + imgs[i] + '" alt="' + (data.title || 'Hilfe') + ' ' + (i+1) + '"></div>';
      }
      detailGallery.innerHTML = h;
    }
  }

  /* left-open: Desktop → slide left detail, Mobile → fullscreen overlay */
  root.querySelectorAll('[data-action="left-open"]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var kind = btn.getAttribute('data-info');
      var data = _s0HelpInfo[kind];
      if (!data) return;

      /* Mobile: overlay */
      if (window.innerWidth <= 700) {
        var ov = root.querySelector('[data-help-overlay]');
        var ovT = root.querySelector('[data-help-overlay-title]');
        var ovDT = root.querySelector('[data-help-overlay-detail-title]');
        var ovTx = root.querySelector('[data-help-overlay-text]');
        var ovGal = root.querySelector('[data-help-overlay-gallery]');
        if (ov && ovT) {
          ovT.textContent = data.title || 'Hilfe';
          if (ovDT) ovDT.textContent = data.title || '';
          if (ovTx) ovTx.innerHTML = data.html || '';
          if (ovGal) {
            var imgs = Array.isArray(data.images) ? data.images : [];
            var h = '';
            for (var i = 0; i < imgs.length; i++) {
              h += '<div class="wiz-left-gallery-item"><img class="wiz-left-gallery-img" src="' + imgs[i] + '" alt="' + (data.title||'Hilfe') + ' ' + (i+1) + '"></div>';
            }
            ovGal.innerHTML = h;
          }
          var ovSlot = root.querySelector('[data-help-overlay-select-slot]');
          if (ovSlot) {
            ovSlot.innerHTML = '<button type="button" class="wiz-overlay-back-btn" data-action="close-help-overlay">Zur\u00FCck</button>';
            ovSlot.querySelector('.wiz-overlay-back-btn').addEventListener('click', function() { ov.classList.remove('is-open'); });
          }
          requestAnimationFrame(function() { ov.classList.add('is-open'); });
        }
        return;
      }

      /* Desktop: left slider detail */
      renderS0LeftDetail(kind);
      setLeftView(true);
      try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch(_e) {}
    });
  });

  /* left-back: schlie\u00dft Detail-Ansicht */
  root.querySelectorAll('[data-action="left-back"]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      setLeftView(false);
      if (window.innerWidth > 700) {
        try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch(_e) {}
      }
    });
  });

  /* close-help-overlay: Mobile overlay schlie\u00dfen */
  root.querySelectorAll('[data-action="close-help-overlay"]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var ov = root.querySelector('[data-help-overlay]');
      if (ov) ov.classList.remove('is-open');
    });
  });

  /* Drawer toggle (mobile peek bar) — single delegated handler */
  root.addEventListener('click', function(e) {
    var s2L = root.querySelector('.s2-left');
    var bd = root.querySelector('.wiz-backdrop');
    /* Close-Drawer hat Priorität */
    var closeEl = e.target.closest('[data-action="close-drawer"]');
    if (closeEl) {
      e.stopPropagation();
      if (s2L) s2L.classList.remove('drawer-open', 'drawer-fullscreen');
      if (bd) bd.classList.remove('is-visible');
      return;
    }
    /* Toggle-Drawer */
    var toggleEl = e.target.closest('[data-action="toggle-drawer"]');
    if (toggleEl) {
      if (!s2L) return;
      s2L.classList.toggle('drawer-open');
      if (bd) bd.classList.toggle('is-visible', s2L.classList.contains('drawer-open'));
    }
  });

  /* Animierte Pfeile (JS, weil Nuclear Reset CSS-Keyframes blockiert) */
  (function bounceArrows() {
    var arrows = root.querySelectorAll('.s0-arrow-down');
    if (!arrows.length) return;
    var start = null;
    function tick(ts) {
      if (!start) start = ts;
      var t = ((ts - start) % 1200) / 1200;
      var y = Math.sin(t * Math.PI * 2) * 3;
      arrows.forEach(function(a) { a.style.setProperty('top', y + 'px', 'important'); });
      if (root.querySelector('.s0-arrow-down')) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  })();

  /* Browser-History: pushState damit Browser-Zurück funktioniert */
  if (window.history && window.history.pushState) {
    window.history.pushState({ isodashStep: 'kapillar' }, '');
  }

  /* Scroll to top */
  var ct = document.getElementById('ct');
  if (ct) { try { ct.scrollTo({ top: 0, behavior: 'smooth' }); } catch(_e) { ct.scrollTop = 0; } }
}

function _step0ClickHandler(e) {
  var card = e.target.closest('[data-s0]');
  if (!card) return;

  var choice = card.getAttribute('data-s0');
  _rootEl.removeEventListener('click', _step0ClickHandler);

  if (choice === 'yes') {
    /* User bestätigt: Kapillarfeuchtigkeit. Trotzdem Step-1 zeigen
       (Aufsteigend = Horizontalsperre vs Seitlich eindringend = Flächensperre)
       — beide Varianten können kapillar sein, brauchen aber unterschiedliche
       Sperr-Konfigurationen. moistureType wird im Step-1 vom User gesetzt. */
    for (var _ck2 in _sharedState) { if (_sharedState.hasOwnProperty(_ck2)) delete _sharedState[_ck2]; }
    _mcAnswers = {};
    _mcQuestionIndex = 0;
    _mcResult = null;
    setFlowState('isodash_entry_mode', 'direct');
    setFlowState('isodash_capillary_check', 'skipped');
    window.logr3Track && window.logr3Track("isodash-kapillar-ja", { step: true });
    startWallWizard(0);
  } else if (choice === 'unsure') {
    /* Unsicher → frische FA, alle alten Antworten weg */
    for (var _ck3 in _sharedState) { if (_sharedState.hasOwnProperty(_ck3)) delete _sharedState[_ck3]; }
    _mcAnswers = {};
    _mcQuestionIndex = 0;
    _mcResult = null;
    setFlowState('isodash_entry_mode', 'unsure');
    setFlowState('isodash_capillary_check', 'pending');
    window.logr3Track && window.logr3Track("isodash-kapillar-unsicher", { step: true });
    startMoistureCheck();
  }
}


/* ══════════════════════════════════════════════════════════════
   ═══ WALL WIZARD (existing Step 0–3 chain) ═══
   ══════════════════════════════════════════════════════════════ */

/* Findet den ersten Step, der noch User-Input braucht — überspringt
   bereits beantwortete Steps (moistureType/masonryType aus FA2). */
function _firstUnansweredStepIndex(startIndex) {
  var idx = (typeof startIndex === 'number' && startIndex >= 0) ? startIndex : 0;
  while (idx < STEP_ORDER.length) {
    var step = STEP_ORDER[idx];
    if (step === 'step-1' && _sharedState.moistureType) { idx++; continue; }
    if (step === 'step-2' && _sharedState.masonryType) { idx++; continue; }
    break;
  }
  return idx;
}

function startWallWizard(startIndex) {
  /* Standalone FA-only: NICHT in den Bedarfsrechner — die Feuchtigkeitsanalyse endet hier,
     die Flaschen-Berechnung macht der Kalkulator. Alle Fit-Pfade (sicher/weiter) laufen
     hierdurch; Nicht-Fit (Kondensation→renderExitScreen) ruft startWallWizard gar nicht. */
  if (_faDoneUrl) {
    /* Feuchtigkeitstyp an den Kalkulator übergeben: der isowiz-step-0 liest moistureType aus
       localStorage '__ISOWIZ__::state' (Z.373-377 in 26-isowiz-step-0.js). Damit kann der
       doneUrl per '#step-0' die Typ-Auswahl (step-1) überspringen. Werte 'bottom'/'side' sind
       in FA-Tool und Wizard identisch; resetAll() läuft nur bei explizitem Reset, nicht beim
       normalen Boot → der vorab geschriebene Typ überlebt. KEINE isowiz-Datei verändert. */
    try {
      var _mt = (_sharedState && _sharedState.moistureType) || 'bottom';
      var _wizKey = '__ISOWIZ__::state';
      var _wizState = {};
      try { _wizState = JSON.parse(localStorage.getItem(_wizKey)) || {}; } catch (_eS) {}
      _wizState.moistureType = _mt;
      localStorage.setItem(_wizKey, JSON.stringify(_wizState));
    } catch (_eHandoff) {}
    try { document.body.style.overflow = ''; } catch (_e) {}
    /* v310.4: Verdict-Routing — bottom → Horizontalsperre-Seite, side → Flaechensperre-Seite; sonst Kalkulator */
      var _dest = (_mt === 'side' && _faDoneSide) ? _faDoneSide : ((_mt === 'bottom' && _faDoneBottom) ? _faDoneBottom : _faDoneUrl);
      /* v445: Attributions-Flag NUR beim Sprung zu einer Loesungsseite -- die Loesungsseite
         (iso-loesung-flow.js) prueft das und feuert darauf das GA4-Lead NUR bei echten
         FA-Tool-Abschluessen, nicht bei Direkt-/Ad-Traffic auf die Loesungsseite. */
      if (_dest === _faDoneBottom || _dest === _faDoneSide) {
        _dest += (_dest.indexOf('?') === -1 ? '?' : '&') + 'fa=1';
        /* v447 Baustein A: FA-Ergebnis fuer den Begruendungs-Block der Loesungsseite
           persistieren (iso-loesung-flow.js renderFaBegruendung liest den Key, Frische-
           Check dort 15 min). Das ?fa=1-Flag taugt dafuer NICHT als Traeger, weil
           fireFaArrivalLead es sofort aus der URL raeumt und der Block einen Reload
           ueberleben soll. answers kommen mit rein: die Deutungs-Map ist auf
           Antwort-Codes (qX:value) gekeyt, nicht auf Reason-Texte. */
        try {
          var _faS = JSON.parse(localStorage.getItem('fa_state_v2')) || {};
          var _faR = _faS.result || {};
          localStorage.setItem('isofin_fa_result_v1', JSON.stringify({
            type: _faR.type || '',
            confidence: _faR.confidence || '',
            kapillarPct: _faR.kapillarPct || 0,
            reasons: _faR.reasons || [],
            answers: _faS.answers || {},
            ts: Date.now()
          }));
          /* v515 Tracking: FA-Ergebnis als Schluesselereignis (Logr3 im Namen, GA4 per isofinGA) */
          try {
            var _faT = String(_faR.type || 'unbekannt').toLowerCase().replace(/[^a-z0-9]+/g, '_');
            window.logr3Track && window.logr3Track('fa_result_' + _faT, { step: true });
            window.isofinGA && window.isofinGA('fa_result', { fa_type: _faT, confidence: String(_faR.confidence || '') });
          } catch (_eFaTr) {}
        } catch (_eFaRes) {}
      }
      try { window.location.href = _dest; } catch (_e) {}
    return;
  }
  _flowPhase = 'wall-wizard';
  setFlowState('isodash_flow_phase', 'wall-wizard');

  /* SKIP-Logik VOR dem Render — verhindert dass step-1/step-2 kurz aufblitzen,
     wenn moistureType/masonryType bereits durch FA2 gesetzt sind. */
  _currentStepIndex = _firstUnansweredStepIndex(startIndex);

  /* Falls alle Steps bereits beantwortet → direkt zum Abschluss */
  if (_currentStepIndex >= STEP_ORDER.length) {
    onAllStepsComplete();
    return;
  }

  /* Push initial Wall-Wizard-Step in History → Back führt zur Kapillarprüfung */
  _pushStepState(STEP_ORDER[_currentStepIndex]);

  /* Loading UI */
  renderLoading(_rootEl);

  /* FAST PATH: React + erster Wizard-Step parallel → render */
  loadFirstStepFast()
    .then(function () {
      if (!_mounted || _flowPhase !== 'wall-wizard') return;
      renderCurrentStep();

      /* Steps 1–3 im Hintergrund nachladen */
      preloadRemainingSteps();
    })
    .catch(function (err) {
      console.error('[IsoDash Analyse] Load failed:', err);
      if (_mounted) renderError(_rootEl, err && err.message);
    });
}


/* ══════════════════════════════════════════════════════════════
   ═══ MOISTURE CHECK (embedded FA2 question runner) ═══
   Lädt FA_CONTENT + FA_SSOT on demand, zeigt 8 Fragen,
   wertet aus und routet zu Wall Wizard oder Exit Screen.
   ══════════════════════════════════════════════════════════════ */

function startMoistureCheck() {
  _flowPhase = 'moisture-check';
  _mcAnswers = {};
  _mcQuestionIndex = 0;
  _mcResult = null;
  window.logr3Track && window.logr3Track("isodash-fa-start", { step: true });

  /* Lock body scroll on mobile */
  if (window.innerWidth <= 700) {
    try { document.body.style.overflow = 'hidden'; } catch(_e) {}
  }

  /* Loading spinner (wrapped in .ihub-mc for mobile fullscreen) */
  if (_rootEl) {
    _rootEl.innerHTML = ''
      + '<div class="ihub-mc">'
      + '<div class="ihub-mc-head">'
      + '<button class="ihub-mc-head-back" style="visibility:hidden">\u2190</button>'
      + '<div class="ihub-mc-head-wrap">'
      + '<div class="ihub-mc-head-title">Feuchtigkeitsanalyse</div>'
      + '<div class="ihub-mc-head-step">Wird geladen\u2026</div>'
      + '</div>'
      + '<button class="ihub-mc-head-close" style="visibility:hidden">\u2715</button>'
      + '</div>'
      + '<div class="ihub-mc-scroll">'
      + '<div style="text-align:center !important;padding:52px 24px !important">'
      + '<div style="width:40px !important;height:40px !important;margin:0 auto 12px !important;border:3px solid rgba(255,255,255,.1) !important;border-top-color:#D6001C !important;border-radius:50% !important;animation:isodash-analyse-spin 1s linear infinite !important"></div>'
      + '<div style="font-size:13px !important;color:var(--ds-text-muted) !important">Feuchtigkeitsanalyse wird geladen\u2026</div>'
      + '</div>'
      + '</div>'
      + '</div>';
  }

  loadFA2Scripts().then(function () {
    if (!_mounted || _flowPhase !== 'moisture-check') return;
    renderMoistureQuestion();
  }).catch(function (err) {
    console.error('[IsoDash Analyse] FA2 load failed:', err);
    if (_mounted) renderError(_rootEl, 'Feuchtigkeitsanalyse konnte nicht geladen werden.');
  });
}

function renderMoistureQuestion() {
  if (!_rootEl || !_mounted) return;

  var qId = MC_QUESTIONS[_mcQuestionIndex];
  var C = window.FA_CONTENT && window.FA_CONTENT.de;
  if (!C || !C.steps || !C.steps[qId]) {
    renderError(_rootEl, 'Fragendaten nicht verf\u00fcgbar.');
    return;
  }

  var q = C.steps[qId];
  var pct = Math.round(((_mcQuestionIndex + 1) / MC_QUESTIONS.length) * 100); /* v311.7: 1-basiert → Balken füllt von 13% auf 100% (statt 0%→88%) */
  var num = _mcQuestionIndex + 1;
  var total = MC_QUESTIONS.length;

  var optsHtml = '';
  q.options.forEach(function (opt) {
    var sel = _mcAnswers[qId] === opt.code ? ' is-selected' : '';
    optsHtml += '<button class="ihub-mc-opt' + sel + '" data-mc-code="' + opt.code + '">'
      + '<span>' + opt.label + '</span>'
      + (opt.help ? '<span class="ihub-mc-opt-help">' + opt.help + '</span>' : '')
      + '</button>';
  });

  var backBtn = '';
  if (_mcQuestionIndex > 0) {
    backBtn = '<button class="ihub-mc-back" data-mc-back>\u2190 Zur\u00fcck</button>';
  } else {
    backBtn = '<button class="ihub-mc-back" data-mc-abort>\u2190 Abbrechen</button>';
  }

  _rootEl.innerHTML = ''
    + '<div class="ihub-mc">'
    + '<div class="ihub-mc-head">'
    + '<button class="ihub-mc-head-back" data-mc-head-back>\u2190</button>'
    + '<div class="ihub-mc-head-wrap">'
    + '<div class="ihub-mc-head-title">Feuchtigkeitsanalyse</div>'
    + '<div class="ihub-mc-head-step">Frage ' + num + ' von ' + total + '</div>'
    + '</div>'
    + '<button class="ihub-mc-head-close" data-mc-head-close>\u2715</button>'
    + '</div>'
    + '<div class="ihub-mc-scroll">'
    + '<div class="ihub-mc-progress">'
    + '<div class="ihub-mc-pbar"><div class="ihub-mc-pbar-fill" style="width:' + pct + '%"></div></div>'
    + '<div class="ihub-mc-ptext">Frage ' + num + ' von ' + total + '</div>'
    + '</div>'
    + '<div class="ihub-mc-card">'
    + '<div class="ihub-mc-card-head"><div class="ihub-mc-card-head-title">' + q.title + '</div></div>'
    + '<div class="ihub-mc-card-body">'
    + '<div class="ihub-mc-question">' + q.question + '</div>'
    + '<div class="ihub-mc-opts">' + optsHtml + '</div>'
    + '<div class="ihub-mc-nav">' + backBtn + '<div></div></div>'
    + '</div>'
    + '</div>'
    + '</div>'
    + '</div>';

  /* Attach click handler via delegation */
  var mcRoot = _rootEl.querySelector('.ihub-mc');
  if (mcRoot) mcRoot.addEventListener('click', _mcClickHandler);

  /* Scroll ALLES nach oben — jede neue Frage muss oben anfangen */
  var ct = document.getElementById('ct');
  if (ct) { try { ct.scrollTo({ top: 0 }); } catch(_e) { ct.scrollTop = 0; } }
  try {
    var _mcScr = _rootEl.querySelector('.ihub-mc-scroll');
    if (_mcScr) _mcScr.scrollTop = 0;
    var _mcCard = _rootEl.querySelector('.ihub-mc-card-body');
    if (_mcCard) _mcCard.scrollTop = 0;
  } catch(_) {}
}

function _mcClickHandler(e) {
  /* Option selected */
  var opt = e.target.closest('[data-mc-code]');
  if (opt) {
    var code = opt.getAttribute('data-mc-code');
    var qId = MC_QUESTIONS[_mcQuestionIndex];
    _mcAnswers[qId] = code;

    /* Visual feedback */
    var allOpts = _rootEl.querySelectorAll('.ihub-mc-opt');
    for (var i = 0; i < allOpts.length; i++) allOpts[i].classList.remove('is-selected');
    opt.classList.add('is-selected');

    /* Advance after short delay */
    setTimeout(function () {
      if (!_mounted || _flowPhase !== 'moisture-check') return;
      if (_mcQuestionIndex < MC_QUESTIONS.length - 1) {
        _mcQuestionIndex++;
        renderMoistureQuestion();
      } else {
        evaluateMoistureResult();
      }
    }, 300);
    return;
  }

  /* Back button */
  var back = e.target.closest('[data-mc-back]');
  if (back) {
    if (_mcQuestionIndex > 0) {
      _mcQuestionIndex--;
      renderMoistureQuestion();
    }
    return;
  }

  /* Abort → back to entry */
  var abort = e.target.closest('[data-mc-abort]');
  if (abort) {
    _exitMoistureCheck();
    return;
  }

  /* Fullscreen header: back button (← prev question, or abort on first) */
  var headBack = e.target.closest('[data-mc-head-back]');
  if (headBack) {
    if (_mcQuestionIndex > 0) {
      _mcQuestionIndex--;
      renderMoistureQuestion();
    } else {
      _exitMoistureCheck();
    }
    return;
  }

  /* Fullscreen header: close button (✕ always aborts) */
  var headClose = e.target.closest('[data-mc-head-close]');
  if (headClose) {
    _exitMoistureCheck();
    return;
  }
}

function _exitMoistureCheck() {
  _flowPhase = 'step0-capillary';
  try { document.body.style.overflow = ''; } catch(_e) {}
  renderStep0Capillary(_rootEl);
}

function evaluateMoistureResult() {
  if (!window.FA_SSOT || typeof window.FA_SSOT.evaluate !== 'function') {
    renderError(_rootEl, 'Diagnose-Engine nicht verf\u00fcgbar.');
    return;
  }

  /* Computing state (keep fullscreen wrapper for mobile) */
  _rootEl.innerHTML = ''
    + '<div class="ihub-mc">'
    + '<div class="ihub-mc-head">'
    + '<button class="ihub-mc-head-back" style="visibility:hidden">\u2190</button>'
    + '<div class="ihub-mc-head-wrap">'
    + '<div class="ihub-mc-head-title">Feuchtigkeitsanalyse</div>'
    + '<div class="ihub-mc-head-step">Auswertung\u2026</div>'
    + '</div>'
    + '<button class="ihub-mc-head-close" style="visibility:hidden">\u2715</button>'
    + '</div>'
    + '<div class="ihub-mc-scroll">'
    + '<div style="text-align:center !important;padding:52px 24px !important">'
    + '<div style="font-size:40px !important;margin-bottom:16px !important">\u23F3</div>'
    + '<div style="font-size:16px !important;font-weight:600 !important;color:var(--ds-text) !important;margin-bottom:8px !important">Auswertung l\u00e4uft\u2026</div>'
    + '<div style="font-size:12px !important;color:var(--ds-text-muted) !important">Ihr Schadensbild wird analysiert.</div>'
    + '</div>'
    + '</div>'
    + '</div>';

  var result = window.FA_SSOT.evaluate(_mcAnswers);
  _mcResult = result;
  /* Global verf\u00fcgbar machen f\u00fcr Hendrik-Kontakt-Drawer */
  try { window._isodashLastFAResult = result; } catch(_e){}

  console.log('[IsoDash Analyse] Moisture check result:', result);

  /* Mauerwerk aus FA q8 in sharedState \u00fcbernehmen */
  var FA_Q8_MAP = {
    'brick': 'ziegelstein',
    'natural_stone': 'naturstein',
    'hollow_block': 'hohlblockziegel',
    'concrete': 'beton'
  };
  var FA_Q8_LABELS = {
    'ziegelstein': 'Ziegelmauerwerk',
    'naturstein': 'Naturstein / Bruchstein',
    'hohlblockziegel': 'Hohlblock / Porenbeton',
    'beton': 'Beton'
  };
  var faQ8 = _mcAnswers && _mcAnswers.q8;
  if (faQ8 && FA_Q8_MAP[faQ8]) {
    _sharedState.masonryType = FA_Q8_MAP[faQ8];
    _sharedState.masonryLabel = FA_Q8_LABELS[FA_Q8_MAP[faQ8]] || FA_Q8_MAP[faQ8];
    _sharedState.isBeton = (FA_Q8_MAP[faQ8] === 'beton');
    setFlowState('isodash_masonry_type', FA_Q8_MAP[faQ8]);
    console.log('[IsoDash Analyse] Mauerwerk aus FA \u00fcbernommen:', _sharedState.masonryType);
  }

  /* Store result in session */
  setFlowState('isodash_moisture_check_completed', '1');
  setFlowState('isodash_capillary_confidence', result.confidence || 'low');
  /* FA-State f\u00fcr Hendrik-Kontakt (WhatsApp/Email) speichern */
  try { localStorage.setItem('fa_state_v2', JSON.stringify({answers:_mcAnswers, result:result})); } catch(_e){}

  setTimeout(function () {
    if (!_mounted) return;

    /* Unlock body scroll before transitioning away from moisture check */
    try { document.body.style.overflow = ''; } catch(_e) {}

    if (result.type === 'kapillar' || result.type === 'kapillar_plus') {
      /* Klar kapillar → aufsteigende Lösungsseite */
      setFlowState('isodash_capillary_fit', 'yes');
      setFlowState('isodash_capillary_check', 'completed');
      _sharedState.moistureType = 'bottom';
      startWallWizard(); /* v311.8: direkt zur Lösungsseite */
    } else if (result.type === 'seitlich') {
      /* Klar seitlich → seitliche Lösungsseite */
      setFlowState('isodash_capillary_fit', 'side');
      setFlowState('isodash_capillary_check', 'completed');
      _sharedState.moistureType = 'side';
      startWallWizard(); /* v311.8: direkt zur Lösungsseite */
    } else {
      /* v312.7: ALLE unklaren/nicht-kapillaren Fälle (unklar, druckwasser, kondensat,
         leitung, Borderline) → direkt an Hendrik/Fachfirma (Exit-Screen mit Kontakt-Block).
         Vorher gingen unklar+kapillarPct≥35 und seitlichPct≥50 noch auf Lösungsseiten. */
      setFlowState('isodash_capillary_fit', 'no');
      setFlowState('isodash_capillary_check', 'completed');
      renderExitScreen(result);
    }
  }, 900);
}


/* ══════════════════════════════════════════════════════════════
   ═══ KAPILLAR RESULT SCREEN (Ergebnis vor Wall-Wizard) ═══
   Zeigt Diagnose-Ergebnis bei kapillarer Feuchtigkeit.
   CTA führt weiter zum Wanddaten-Wizard.
   ══════════════════════════════════════════════════════════════ */

/* Helper: Baut eine lesbare Zusammenfassung aller FA-Antworten */
function _buildAnswerSummary(result) {
  if (!result || !result.reasons || !result.reasons.length) return '';
  var html = '<div style="background:var(--ds-surface-el) !important;border:1px solid var(--ds-border) !important;border-radius:12px !important;padding:16px !important;margin-bottom:16px !important;text-align:left !important">';
  html += '<div style="font-size:14px !important;font-weight:700 !important;color:var(--ds-text) !important;margin-bottom:10px !important">\uD83D\uDCDD Ihre Angaben aus der Analyse</div>';
  html += '<ul style="list-style:none !important;padding:0 !important;margin:0 !important">';
  result.reasons.forEach(function(r){
    html += '<li style="font-size:13px !important;color:var(--ds-text-muted) !important;padding:4px 0 4px 18px !important;position:relative !important;line-height:1.5 !important">';
    html += '<span style="position:absolute !important;left:0 !important;color:var(--ds-green) !important;font-weight:700 !important">\u2713</span>' + r;
    html += '</li>';
  });
  html += '</ul></div>';
  return html;
}

/* Helper: Disclaimer-Text */
function _disclaimerHtml() {
  return '<div style="font-size:11px !important;color:var(--ds-text-dim) !important;text-align:center !important;padding:12px 16px !important;line-height:1.5 !important;margin-top:8px !important">'
    + 'Hinweis: Diese Einsch\u00e4tzung basiert auf Ihren Angaben und unserer bestm\u00f6glichen Berechnung. Eine abschlie\u00dfende Beurteilung ist nur vor Ort m\u00f6glich.'
    + '</div>';
}

function renderKapillarResultScreen(result) {
  _flowPhase = 'kapillar-result';
  if (!_rootEl) return;

  var kapPct = result.kapillarPct || 0;
  var resultType = result.type || '';
  /* Druckwasser / Ausschluss → Hendrik-Kontakt */
  var isExclusion = (resultType === 'druckwasser' || resultType === 'leitung');

  /* Tracking */
  window.logr3Track && window.logr3Track("isodash-fa-complete", { step: true });
  if (isExclusion) {
    window.logr3Track && window.logr3Track("isodash-fa-result-hendrik", { step: true });
  } else {
    window.logr3Track && window.logr3Track("isodash-fa-result-kapillar", { step: true });
  }

  var isPlus = (result.type === 'kapillar_plus');
  var isBorderline = (result.type === 'unklar');
  var isSide = (_sharedState.moistureType === 'side');

  /* Confidence-Badge wurde entfernt — User soll nicht "mittlere Sicherheit" sehen.
     Statt dessen einfach klare Aussage "Kapillare Feuchtigkeit erkannt". */

  /* Headline */
  var headline = isPlus
    ? 'Aufsteigende Feuchtigkeit + seitliches Eindringen erkannt'
    : isSide
      ? 'Seitlich eindringende Feuchtigkeit erkannt'
      : isBorderline
        ? 'Kapillare Feuchtigkeit m\u00f6glich'
        : 'Kapillare Feuchtigkeit erkannt';

  /* Reason chips — Druckwasser: NUR der Ausschlussgrund. Kapillar: KEINE Chips. */
  var reasonsHtml = '';
  if (isExclusion) {
    var excDesc = (result.description) || (result.reasons && result.reasons[0]) || '';
    if (excDesc) {
      reasonsHtml = '<div style="font-size:14px !important;color:var(--ds-accent) !important;font-weight:600 !important">\u26A0\uFE0F ' + excDesc + '</div>';
    }
  }
  /* Kapillar: keine Reason-Chips — saubere klare Aussage reicht */

  _rootEl.innerHTML = ''
    + '<div class="ihub-mc">'
    + '<div class="ihub-mc-head">'
    + '<button class="ihub-mc-head-back" style="visibility:hidden">\u2190</button>'
    + '<div class="ihub-mc-head-wrap">'
    + '<div class="ihub-mc-head-title">Feuchtigkeitsanalyse</div>'
    + '<div class="ihub-mc-head-step">Ergebnis</div>'
    + '</div>'
    + '<button class="ihub-mc-head-close" data-kapres="restart" style="cursor:pointer !important">\u2715</button>'
    + '</div>'
    + '<div class="ihub-mc-scroll">'
    /* Footer ist als separater flex-Item NACH .ihub-mc-scroll — kein extra Padding nötig */
    + '<div style="padding:24px !important;text-align:center !important">'

    /* Result icon */
    + '<div style="font-size:48px !important;margin-bottom:16px !important">'
    + (isBorderline ? '\uD83D\uDD0D' : '\u2705') + '</div>'

    /* Headline — klar und kurz, KEIN Confidence-Badge */
    + '<div style="font-size:18px !important;font-weight:700 !important;color:var(--ds-text) !important;margin-bottom:8px !important;line-height:1.4 !important">'
    + 'Ergebnis Ihrer Feuchte-Analyse</div>'
    + '<div style="font-size:16px !important;color:var(--ds-text) !important;font-weight:600 !important;margin-bottom:20px !important;line-height:1.4 !important">'
    + headline + '</div>'

    /* Reason chips */
    + (reasonsHtml ? '<div style="display:flex !important;flex-wrap:wrap !important;gap:6px !important;justify-content:center !important;margin-bottom:20px !important">' + reasonsHtml + '</div>' : '')

    /* Explanation + CTAs — abhängig vom Ergebnistyp */
    + (isExclusion
      ? /* ─── DRUCKWASSER → NUR Ausschlussgrund + Hendrik-Kontakt (keine Antwortenliste) ─── */
        '<div style="background:rgba(214,0,28,.06) !important;border:1px solid rgba(214,0,28,.20) !important;border-radius:12px !important;padding:18px !important;margin-bottom:16px !important;text-align:left !important">'
        + '<div style="font-size:15px !important;font-weight:700 !important;color:var(--ds-text) !important;margin-bottom:8px !important">\u26A0\uFE0F Es liegt voraussichtlich kein Fall f\u00fcr Isofin\u00ae vor</div>'
        + '<div style="font-size:13px !important;color:var(--ds-text-muted) !important;line-height:1.7 !important">'
        + 'Ihre Angaben deuten auf <strong>Druckwasser oder einen Wasserschaden</strong> hin \u2014 nicht auf kapillar aufsteigende Feuchtigkeit. '
        + 'Bitte wenden Sie sich an unseren Mauerwerksexperten Hendrik f\u00fcr eine pers\u00f6nliche Einsch\u00e4tzung.'
        + '</div></div>'
        + '<div style="font-size:12px !important;color:var(--ds-text-dim) !important;margin-bottom:8px !important;text-align:center !important">Ihre Angaben werden bei WhatsApp/E-Mail automatisch mitgesendet.</div>'
      : /* ─── KAPILLAR → Erklärung + Wanddaten-CTA (kein Sticky) ─── */
        '<div style="background:var(--ds-surface-el) !important;border-radius:12px !important;padding:16px !important;margin-bottom:16px !important;text-align:left !important">'
        + '<div style="font-size:15px !important;font-weight:600 !important;color:var(--ds-text) !important;margin-bottom:8px !important">Was das f\u00fcr Ihre Wand bedeutet</div>'
        + '<div style="font-size:13px !important;color:var(--ds-text-muted) !important;line-height:1.7 !important">'
        + 'Es liegt sehr wahrscheinlich <strong>kapillare Feuchtigkeit</strong> in Ihrem Mauerwerk vor. '
        + 'Isofin\u00ae kann diesen Transport dauerhaft unterbrechen. '
        + 'Im n\u00e4chsten Schritt geben Sie Ihre Wanddaten ein \u2014 damit wir Menge, Bohrtiefe und Kosten exakt berechnen k\u00f6nnen.'
        + '</div></div>'
        /* Primary CTA: Wanddaten eingeben (KEIN Sticky, direkt im Content) */
        + '<button data-kapres="proceed" style="display:flex !important;align-items:center !important;justify-content:center !important;gap:10px !important;width:100% !important;max-width:420px !important;margin:0 auto 16px !important;padding:16px 24px !important;background:linear-gradient(180deg,#D6001C 0%,#A80016 100%) !important;color:#fff !important;border:none !important;border-radius:14px !important;font-family:inherit !important;font-size:17px !important;font-weight:700 !important;cursor:pointer !important;box-shadow:0 6px 16px rgba(214,0,28,.35),0 3px 6px rgba(0,0,0,.2),inset 0 -2px 0 rgba(0,0,0,.15) !important;white-space:nowrap !important">'
        + 'Wanddaten eingeben <span class="ihub-entry-cta-arrow cta-arrow">\u2192</span></button>'
    )
    /* DISCLAIMER */
    + '<div style="margin-bottom:14px !important;padding:14px 16px !important;background:var(--ds-surface-el) !important;border:1px solid var(--ds-border) !important;border-radius:10px !important;font-size:12.5px !important;color:var(--ds-text-muted) !important;line-height:1.55 !important;text-align:left !important">'
    + '<strong style="color:var(--ds-text) !important">Hinweis:</strong> Diese Einsch\u00e4tzung basiert auf Ihren Angaben und unserer bestm\u00f6glichen Berechnung. Eine abschlie\u00dfende Beurteilung der Situation vor Ort obliegt dem Anwender bzw. einem Fachberater.'
    + '</div>'
    /* Sekundär: Expertenhilfe (nur Kapillar) */
    + (isExclusion ? '' :
        '<button data-kapres="expert" style="display:inline-flex !important;align-items:center !important;justify-content:center !important;gap:8px !important;width:100% !important;max-width:420px !important;padding:12px 20px !important;font-size:14px !important;font-weight:600 !important;border-radius:10px !important;background:transparent !important;color:var(--ds-accent) !important;border:1.5px solid var(--ds-accent-border) !important;cursor:pointer !important;margin-bottom:8px !important;font-family:inherit !important">'
        + '\uD83D\uDCAC Expertenhilfe anfragen</button>'
    )
    /* Tertiär: Analyse neu starten */
    + '<div style="margin-top:14px !important;padding-top:14px !important;border-top:1px solid var(--ds-border) !important;text-align:center !important">'
    + '<button data-kapres="restart" style="background:transparent !important;border:1px solid var(--ds-border) !important;cursor:pointer !important;font-size:13px !important;color:var(--ds-text-muted) !important;padding:10px 18px !important;border-radius:8px !important;font-family:inherit !important">'
    + '\u21BB Analyse neu starten</button>'
    + '</div>'

    + '</div>'
    + '</div>'
    /* STICKY-FOOTER — NUR bei DRUCKWASSER (Expertenhilfe). Kapillar hat CTA im Content. */
    + (isExclusion
      ? '<div class="ihub-mc-result-foot" style="flex-shrink:0 !important;background:var(--ds-bg) !important;border-top:1px solid var(--ds-border) !important;padding:14px 16px calc(14px + env(safe-area-inset-bottom,0px)) !important">'
        + '<button data-kapres="expert" style="display:flex !important;align-items:center !important;justify-content:center !important;gap:10px !important;width:100% !important;max-width:480px !important;margin:0 auto !important;padding:14px 20px !important;background:linear-gradient(180deg,#D6001C 0%,#A80016 100%) !important;color:#fff !important;border:none !important;border-radius:14px !important;font-family:inherit !important;font-size:16px !important;font-weight:700 !important;cursor:pointer !important;box-shadow:0 6px 16px rgba(214,0,28,.35),0 3px 6px rgba(0,0,0,.2),inset 0 -2px 0 rgba(0,0,0,.15) !important;letter-spacing:.3px !important">'
        + '<span style="position:relative !important;display:inline-flex !important;align-items:center !important;justify-content:center !important;width:36px !important;height:36px !important;min-width:36px !important;max-width:36px !important;min-height:36px !important;max-height:36px !important;aspect-ratio:1/1 !important;flex-shrink:0 !important;border-radius:50% !important;overflow:hidden !important;background:#fff !important;border:2px solid rgba(255,255,255,.5) !important;box-shadow:0 2px 6px rgba(0,0,0,.15) !important">'
        + '<img src="https://cdn.shopify.com/s/files/1/0846/5550/5691/files/2026-hendrik-fluegge-blau-avatar-mittel-300px.jpg?v=1790351554" alt="Hendrik" style="width:100% !important;height:100% !important;object-fit:cover !important;display:block !important;border-radius:50% !important">'
        + '</span>'
        + '<span style="display:inline-flex !important;align-items:center !important;gap:8px !important;white-space:nowrap !important">Expertenhilfe anfragen <span class="ihub-entry-cta-arrow cta-arrow" style="width:22px !important;height:22px !important;min-width:22px !important;font-size:13px !important">\u2192</span></span>'
        + '</button>'
        + '</div>'
      : '' /* Kapillar: kein Sticky-Footer — CTA ist im Content */
    )
    + '</div>';

  _rootEl.addEventListener('click', _kapResClickHandler);

  /* Scroll to top */
  var ct = document.getElementById('ct');
  if (ct) { try { ct.scrollTo({ top: 0, behavior: 'smooth' }); } catch(_e) { ct.scrollTop = 0; } }
}

function _kapResClickHandler(e) {
  var btn = e.target.closest('[data-kapres]');
  if (!btn) return;

  var action = btn.getAttribute('data-kapres');

  if (action === 'proceed') {
    _rootEl.removeEventListener('click', _kapResClickHandler);
    try { document.body.style.overflow = ''; } catch(_e) {}
    startWallWizard(0);
  } else if (action === 'expert') {
    /* FA-Antworten f\u00fcr Hendrik-Kontakt verf\u00fcgbar machen */
    try {
      var faContext = {
        source: 'feuchtigkeitsanalyse',
        result: window._isodashLastFAResult || null,
        answers: _mcAnswers || {}
      };
      window._isodashContactContext = faContext;
    } catch(_e){}
    if (window.IsoDashContact && typeof IsoDashContact.openExpert === 'function') {
      IsoDashContact.openExpert(window._isodashContactContext);
    } else if (window.IsoDashContact && typeof IsoDashContact.waLink === 'function') {
      var waUrl = IsoDashContact.waLink();
      if (window.innerWidth < 768) { location.href = waUrl; }
      else { window.open(waUrl, '_blank'); }
    }
  } else if (action === 'restart') {
    _rootEl.removeEventListener('click', _kapResClickHandler);
    try { document.body.style.overflow = ''; } catch(_e) {}
    clearFlowState();
    renderEntryScreen(_rootEl);
  }
}


/* ══════════════════════════════════════════════════════════════
   ═══ EXIT SCREEN (non-capillary result) ═══
   ══════════════════════════════════════════════════════════════ */

function renderExitScreen(result) {
  _flowPhase = 'exit';

  /* v312.7: Auf der FA-Tool-Seite liegt der volle Hendrik-Kontaktblock (#fa-hendrik-result)
     bereits hidden im DOM. Bei Nicht-Fit zeigen wir IHN direkt — Headline aufs Ergebnis
     angepasst — statt Button → Schublade. Fallback (Dashboard, kein Block) = bisheriges Verhalten. */
  var _faHR = document.getElementById('fa-hendrik-result');
  if (_faHR) {
    var FA_HENDRIK = {
      druckwasser: { h: 'Drückendes Wasser?<br><span class="hc-highlight">Das ist kein Fall zum Selbermachen.</span>', s: 'Hier reicht eine Online-Analyse nicht aus: Die richtige Lösung hängt von Bauwerk, Abdichtung und Wasserlast im Einzelfall ab. Unsere Empfehlung: Holen Sie sich zuerst die Einschätzung unseres <strong>Bau-Experten</strong> – <strong>kostenlos</strong> &amp; unverbindlich, kein Callcenter.' },
      kondensat:   { h: 'Kondens- / Oberflächenfeuchte?<br><span class="hc-highlight">Das sollte ein Experte einordnen.</span>', s: 'Ob wirklich nur Kondenswasser dahintersteckt, lässt sich online nicht sicher beurteilen. Holen Sie sich die Einschätzung unseres <strong>Bau-Experten</strong> – <strong>kostenlos</strong> &amp; unverbindlich, kein Callcenter.' },
      leitung:     { h: 'Verdacht auf Leitungswasser?<br><span class="hc-highlight">Zuerst die Quelle klären – kein Fall zum Selbermachen.</span>', s: 'Bevor irgendetwas saniert wird, muss die Wasserquelle sicher gefunden werden – das kann eine Online-Analyse nicht leisten. Sprechen Sie mit unserem <strong>Bau-Experten</strong>: <strong>kostenlos</strong> &amp; unverbindlich.' },
      _default:    { h: 'Ihr Fall ist nicht eindeutig.<br><span class="hc-highlight">Das klärt am besten unser Experte mit Ihnen.</span>', s: 'Bei unklaren Feuchtebildern reicht eine Online-Analyse für eine saubere Einschätzung nicht aus. Unser <strong>Bau-Experte</strong> – kein Callcenter – sagt Ihnen <strong>kostenlos</strong> &amp; unverbindlich, was zu tun ist.' }
    };
    var _c = FA_HENDRIK[(result && result.type)] || FA_HENDRIK._default;
    var _hl = document.getElementById('fa-hr-headline'); if (_hl) _hl.innerHTML = _c.h;
    var _sl = document.getElementById('fa-hr-subline'); if (_sl) _sl.innerHTML = _c.s;
    var _iso = document.getElementById('isodash'); if (_iso) _iso.hidden = true;
    _faHR.hidden = false;
    try { if (window.HendrikContact && HendrikContact.update) HendrikContact.update(); } catch(_e) {}
    /* A5 (Auftrag 2026-09): Bisher meldete nur der Weg auf die Loesungsseiten einen
       FA-Typ. Ausschluss-Ergebnisse (Druckwasser, Kondensat, Leitung) landen hier und
       waren im Trichter unsichtbar — dabei ist genau das der Fall, in dem Isofin NICHT
       passt und der Kunde zu Hendrik gehoert. */
    try {
      var _xT = String((result && result.type) || 'unbekannt').toLowerCase().replace(/[^a-z0-9]+/g, '_');
      window.logr3Track && window.logr3Track('fa_result_' + _xT, { step: true });
      window.isofinGA && window.isofinGA('fa_result', { fa_type: _xT, confidence: String((result && result.confidence) || '') });
    } catch (_eXT) {}
    try { window.logr3Track && window.logr3Track('fa_result_hendrik', { step: true, type: (result && result.type) || 'unklar' }); } catch(_e) {}
    try { _faHR.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch(_e) { try { window.scrollTo(0, 0); } catch(_e2) {} }
    return;
  }

  if (!_rootEl) return;

  var C = window.FA_CONTENT && window.FA_CONTENT.de;
  var resultContent = (C && C.results && C.results[result.type]) || {};

  var title = resultContent.title || 'Ergebnis Ihrer Feuchtigkeitsanalyse';
  var icon = resultContent.icon || '\u26A0\uFE0F';

  /* NUR der Ausschlussgrund — keine Antwortenliste, kein Confidence-Badge */
  var excDesc = (result.description) || (result.reasons && result.reasons[0]) || '';

  _rootEl.innerHTML = ''
    + '<div class="ihub-exit">'
    + '<div class="ihub-exit-icon">' + icon + '</div>'
    + '<div class="ihub-exit-hl">' + title + '</div>'
    + '<div class="ihub-exit-text">Die Online-Berechnung im Dashboard ist f\u00fcr kapillare Feuchtigkeit im Mauerwerk gedacht. Bei Ihrem Schadensbild empfehlen wir eine fachliche Pr\u00fcfung.</div>'
    + (excDesc ? '<div style="text-align:center !important;font-size:14px !important;color:var(--ds-accent) !important;font-weight:600 !important;margin-bottom:16px !important">\u26A0\uFE0F ' + excDesc + '</div>' : '')
    + '<div style="margin:16px 0 !important;padding:14px 16px !important;background:var(--ds-surface-el) !important;border:1px solid var(--ds-border) !important;border-radius:10px !important;font-size:12.5px !important;color:var(--ds-text-muted) !important;line-height:1.55 !important;text-align:left !important">'
    + '<strong style="color:var(--ds-text) !important">Hinweis:</strong> Diese Einsch\u00e4tzung basiert auf Ihren Angaben und unserer bestm\u00f6glichen Berechnung. Eine abschlie\u00dfende Beurteilung der Situation vor Ort obliegt dem Anwender bzw. einem Fachberater.</div>'
    + '<div class="ihub-exit-ctas">'
    + '<button class="ihub-exit-cta-primary" data-exit="expert">Expertenhilfe anfragen</button>'
    + '<button class="ihub-exit-cta-secondary" data-exit="restart">Analyse neu starten</button>'
    + '</div>'
    + '</div>';

  _rootEl.addEventListener('click', _exitClickHandler);

  /* Scroll to top */
  var ct = document.getElementById('ct');
  if (ct) { try { ct.scrollTo({ top: 0, behavior: 'smooth' }); } catch(_e) { ct.scrollTop = 0; } }
}

function _exitClickHandler(e) {
  var btn = e.target.closest('[data-exit]');
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();

  var action = btn.getAttribute('data-exit');

  if (action === 'restart') {
    _rootEl.removeEventListener('click', _exitClickHandler);
    clearFlowState();
    if (_rootEl) renderEntryScreen(_rootEl);
  } else if (action === 'expert') {
    /* Hendrik-Kontakt: Handler bleibt aktiv, Drawer kann beliebig oft geöffnet werden */
    if (window.IsoDashContact && typeof IsoDashContact.openExpert === 'function') {
      IsoDashContact.openExpert();
    } else if (window.ID && typeof ID.menu === 'function') {
      ID.menu();
    }
  }
}


/* ═══ PUBLIC API: mount / unmount ═══ */
function mount(mountCtx) {
  _ensureUtils();
  var root = mountCtx.root;
  var store = mountCtx.store;
  var navigate = mountCtx.navigate;
  var isMobile = mountCtx.isMobile;

  _rootEl = root;
  _storeRef = store;
  _navigateRef = navigate;
  _isMobile = !!isMobile;
  /* Standalone FA-only (von isodash-standalone.js gesetzt) */
  _faMode = (mountCtx.mode === 'fa-only');
  _faDoneUrl = _faMode ? (mountCtx.doneUrl || '/pages/kalkulator') : null;
  _faDoneBottom = _faMode ? (mountCtx.doneBottom || '') : null;
  _faDoneSide = _faMode ? (mountCtx.doneSide || '') : null;
  _currentStepIndex = 0;
  /* Shared State: Properties löschen statt Objekt ersetzen — Referenz für _ctx.state behalten */
  for (var _ck4 in _sharedState) { if (_sharedState.hasOwnProperty(_ck4)) delete _sharedState[_ck4]; }
  _mounted = true;

  /* Bereits beantwortete Werte aus localStorage in _sharedState restaurieren —
     verhindert dass Step-1/Step-2 nochmal erscheinen, wenn User in vorheriger
     Session schon FA durchlaufen ist.
     WICHTIG: NUR wenn echte Berechnung vorliegt (calculatedBottles>0).
     Sonst sind das Reste vom letzten Reset und User würde fälschlicherweise
     übersprungene Schritte sehen. */
  try {
    var _hasValidAnalysis = false;
    if (window.IsoDash && window.IsoDash.Calculations &&
        typeof window.IsoDash.Calculations.getFinalAnalysis === 'function') {
      var _lastA = window.IsoDash.Calculations.getFinalAnalysis();
      if (_lastA && _lastA.calculatedBottles > 0) {
        _hasValidAnalysis = true;
        if (_lastA.masonryType) {
          _sharedState.masonryType = _lastA.masonryType;
          _sharedState.isBeton = (_lastA.masonryType === 'beton');
        }
        if (_lastA.moistureType) _sharedState.moistureType = _lastA.moistureType;
      }
    }
    /* Fallback nur wenn Analyse gültig — Flow-State-Keys allein zählen nicht */
    if (_hasValidAnalysis) {
      var _savedMasonry = getFlowState('isodash_masonry_type');
      if (_savedMasonry && !_sharedState.masonryType) {
        _sharedState.masonryType = _savedMasonry;
        _sharedState.isBeton = (_savedMasonry === 'beton');
      }
      var _savedMoist = getFlowState('isodash_moisture_type');
      if (_savedMoist && !_sharedState.moistureType) _sharedState.moistureType = _savedMoist;
    }
  } catch(_) {}

  /* Namespace und Shims aufsetzen */
  ensureNamespace();
  setupSafeNav();
  injectDarkThemeCSS();

  /* Browser-Zurück: popstate Handler */
  if (!window._isodashPopstateActive) {
    window._isodashPopstateActive = true;
    window.addEventListener('popstate', function(e) {
      if (!_mounted) return;
      var st = e.state;
      if (!st) return;
      if (st.isodashStep === 'entry') {
        /* Zurück zum Entry-Screen */
        unmountCurrentStep();
        _flowPhase = 'entry';
        renderEntryScreen(_rootEl);
      } else if (st.isodashWizStep) {
        /* Zurück zu einem bestimmten Wizard-Step */
        var idx = STEP_ORDER.indexOf(st.isodashWizStep);
        if (idx >= 0 && idx !== _currentStepIndex) {
          unmountCurrentStep();
          _currentStepIndex = idx;
          renderCurrentStep();
        }
      } else if (st.isodashStep === 'kapillar') {
        /* Zurück zur Kapillarprüfung (Step 0 inline) */
        unmountCurrentStep();
        _flowPhase = 'kapillar';
        renderStep0Wizard(_rootEl);
      }
    });
  }

  var navShim = createNavShim();
  window.IsoDash.Navigation = navShim;

  _ctx = {
    nav: navShim,
    ui: window.IsoDash.UI,
    config: window.IsoDash.Config,
    calculations: window.IsoDash.Calculations || {},
    state: _sharedState,
    stepId: STEP_ORDER[0],
    navState: { stepId: STEP_ORDER[0], direction: 'init', viewState: 'step' }
  };

  /* Spinner-Animation injizieren (benötigt für alle Loading-States) */
  if (!document.getElementById('isodash-analyse-spin-css')) {
    var s = document.createElement('style');
    s.id = 'isodash-analyse-spin-css';
    s.textContent = '@keyframes isodash-analyse-spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}';
    document.head.appendChild(s);
  }

  /* ─── FLOW ROUTING ─── */
  /* Standalone FA-only: direkt in die symptombasierte Kurzanalyse (8 Fragen) — KEINE
     Kapillar-Vorabfrage ("Ist Ihr Schaden kapillar?"), denn genau das findet das Tool
     heraus. Kein Bedarfsrechner-Entry, keine alte Berechnung. Diagnose->Fit geht via
     startWallWizard-Guard zum Kalkulator, kein Fit -> renderExitScreen. */
  if (_faMode) { startMoistureCheck(); return; }

  var savedPhase = getFlowState('isodash_flow_phase');

  /* Prüfe ob bereits eine Berechnung existiert */
  var hasExisting = false;
  try {
    if (window.IsoDash && window.IsoDash.Calculations && typeof window.IsoDash.Calculations.getFinalAnalysis === 'function') {
      var existing = window.IsoDash.Calculations.getFinalAnalysis();
      if (existing && existing.calculatedBottles > 0) hasExisting = true;
    }
    if (!hasExisting) {
      var stored = localStorage.getItem('isofinAnalysis') || localStorage.getItem('__ISOWIZ_analysis');
      if (stored) {
        var parsed = JSON.parse(stored);
        if (parsed && parsed.calculatedBottles > 0) hasExisting = true;
      }
    }
  } catch(_e) {}

  if (hasExisting) {
    /* Berechnung existiert → Transition nur EINMALIG nach frischer Berechnung.
       Beim zweiten Besuch (auch nach Reload): statische Ergebnisseite ohne Animation.
       Flag wird in localStorage gespeichert damit es Page-Reloads übersteht. */
    var _transKey = 'isodash_transition_shown';
    var _transShown = false;
    try { _transShown = !!localStorage.getItem(_transKey); } catch(_e2) {}

    if (!_transShown) {
      /* Erster Aufruf nach Berechnung → Animation + Auto-Redirect */
      try { localStorage.setItem(_transKey, '1'); } catch(_e2) {}
      renderTransitionScreen();
    } else {
      /* Wiederholter Besuch → statische Seite */
      renderReturnScreen();
    }
  } else if (savedPhase === 'wall-wizard') {
    /* Returning from another module → resume wall wizard directly */
    startWallWizard();
  } else if (savedPhase === 'step0-capillary') {
    /* Resume Step 0 */
    renderStep0Capillary(root);
  } else if (sessionStorage.getItem('isodash_auto_fa') === '1') {
    /* Auto-start Feuchte-Analyse (von Wirkungsmodul verlinkt) */
    sessionStorage.removeItem('isodash_auto_fa');
    renderStep0Capillary(root);
    /* Simuliere "Unsicher"-Klick */
    setTimeout(function() {
      var unsureCard = root.querySelector('[data-s0="unsure"]');
      if (unsureCard) unsureCard.click();
    }, 300);
  } else {
    /* Fresh start → Entry Screen */
    renderEntryScreen(root);
  }
}

function unmount() {
  _mounted = false;
  unmountCurrentStep();
  removeDarkThemeCSS();
  _rootEl = null;
  _storeRef = null;
  _navigateRef = null;
  _ctx = null;
  _flowPhase = 'entry';

  /* Body-Styles aufräumen die Steps gesetzt haben könnten */
  try { document.body.style.overflow = ''; } catch (_e) {}
  try { document.body.style.overscrollBehavior = ''; } catch (_e) {}
  try { document.documentElement.style.overflowY = ''; } catch (_e) {}

  /* Shopify Footer wiederherstellen (Steps verstecken ihn) */
  try {
    var ft = document.querySelector('.shopify-section-group-footer-group');
    if (ft) ft.style.display = '';
  } catch (_e) {}
}



/* Module self-registration */
window.IsoDashModules = window.IsoDashModules || {};
window.IsoDashModules["analyse"] = {
  mount: mount,
  unmount: unmount,
  goEntry: function() { if (_rootEl) renderEntryScreen(_rootEl); },
  goKapillar: function() { if (_rootEl) renderStep0Capillary(_rootEl); }
};

})();
